import type { Translation } from '../i18n-types';
import baseLanguageValues from '../en-US';

export const translationValues: Partial<Translation> = {
    SHEETS: 'Radni listovi',
    DASHBOARDS: 'Nadzorne ploče',
    DATABASE_TABLE: 'Baza podataka',
    VARIABLES: 'Varijable',
    FILES: 'Datoteke',
    APPS: 'Aplikacije',
    LABEL: 'Oznaka',
    EDIT_TYPE: 'Vrsta uređivanja',
    EDITING_ROW: 'Uređivanje retka {label}',
    CREATE_NEW_ROW: 'Kreiraj novi red',
    ADD: 'Dodaj',
    MULTIPLY: 'Pomnoži',
    SET: 'Postavi',
    PERCENT_CHANGE: 'Promjena postotka',
    NAME: 'Ime',
    NAME_AND_STYLE: 'Naziv i stil',
    PATH: 'Putanja',
    SHARE_WITH: 'Podijeli sa',
    SUBMIT: 'Pošalji',
    EDIT: 'Uredi',
    ANY: 'Bilo koji',
    VIEW: 'Pogledaj',
    EDITING: 'Uređivanje',
    DUPLICATE: 'Dupliciraj',
    DUPLICATE_SHEET_LOADING: 'Dupliciranje radnog lista...',
    DUPLICATE_SHEET_SUCCESS: 'Radni list je uspješno dupliciran',
    DUPLICATE_SHEET_ERROR: 'Greška prilikom dupliciranja radnog lista',
    DUPLICATE_FOLDER_LOADING: 'Dupliciranje mape...',
    DUPLICATE_FOLDER_SUCCESS: 'Mapa je uspješno duplicirana',
    DUPLICATE_FOLDER_ERROR: 'Greška prilikom dupliciranja mape',
    DELETE_TILE: 'Obriši element',
    MATCH_CASE: 'Razlikuj velika/mala slova',
    SEARCH: 'Pretraži',
    SEARCH_VALUES: 'Pretraži vrijednosti',
    IMPORT: 'Uvoz',
    MODEL_HEALTH: 'Zdravlje modela',
    CHECKLIST: 'Kontrolna lista',
    DYNAMIC_ANALYSIS: 'Dinamička analiza',
    STATIC_ANALYSIS: 'Statička analiza',
    CALCULATION_LOGS: 'Zapisi izračuna',
    ERROR_MESSAGE: 'Poruka greške',
    CALCULATION_TIME_MS: 'Vrijeme izračuna (ms)',
    ERRORS: 'Greške',
    WARNINGS: 'Upozorenja',
    AMPLIFICATION_FACTOR: 'Faktor pojačanja',
    CELL_COUNT_ESTIMATE: 'Broj ćelija (procjena)',
    NO_CALCULATION_ERRORS: 'Nema grešaka izračuna',
    CALCULATION_ERRORS: 'Pronađene greške izračuna',
    NO_MODELLING_ERRORS: 'Nema grešaka modeliranja',
    MODELLING_ERRORS: 'Pronađene greške modeliranja',
    MODEL_FULLY_LOADED: 'Model je potpuno učitan',
    MODEL_NOT_LOADED: 'Model nije učitan',
    SHARING: 'Dijeljenje',
    ASSIGNMENT: 'Zadatak',
    ASSIGNMENTS: 'Zadaci',
    LOAD_MORE: 'Učitaj još',
    SHARES: 'Dionice',
    SHARE: 'Podijeli',
    OPEN: 'Otvori',
    NONE: 'Ništa',
    TABLE: 'Tabela',
    VALUE: 'Vrijednost',
    DATE: 'Datum',
    NONE_SELECTED: 'Ništa odabrano',
    VALUE_FOR_MONTH: 'Vrijednost za mjesec',
    DESCRIPTION: 'Opis',
    NOTES: 'Bilješke',
    CUSTOM_FIELD: 'Prilagođeno polje',
    TABLE_DESCRIPTION: 'Opis tabele',
    EDIT_COLUMN: 'Uredi stupac',
    COLUMN_TYPE: 'Vrsta stupca',
    MONTH: 'Mjesec',
    VARIABLE_AND_DIMENSIONS: 'Varijabla & dimenzije',
    SHOW_UNMAPPED: 'Odaberi samo nespojene stavke',
    MANUAL_MAPPING: 'Ručno mapiranje',
    CLEAR: 'Očisti',
    AUTODETECT: 'Automatsko otkrivanje',
    FILTER: 'Filter',
    SELECT_ALL_BRACKETS: '(Odaberi sve)',
    BLANK_CELLS_BRACKETS: '(Prazne ćelije)',
    SELECT_DIMENSIONS: 'Odaberi dimenzije',
    CONFIRM: 'Potvrdi',
    REMOVE_ALL_MAPPINGS_CONFIRM: 'Jeste li sigurni da želite ukloniti sve mapiranja?',
    REMOVE_MANUALLY_ADDED_MAPPING_TAGS: 'Ova akcija će ukloniti sve ručno dodane oznake mapiranja.',
    ERROR_IMPORTING_FILE: 'Greška prilikom uvoza datoteke',
    CHOOSE_JOB_TO_REPLACE: 'Odaberi posao za zamjenu',
    PREVIOUS_IMPORTS: 'Prethodni uvozi',
    WELCOME_TO_IMPORT: 'Dobrodošli na uvoz.',
    IMPORT_SPREADSHEETS: 'Uvezi svoje tablice iz Excela direktno u Farseer i upravljaj njima.',
    DRAG_FILE_HERE: 'Povuci svoju datoteku ovdje',
    OR: 'ILI',
    BROWSE: 'Pregledaj',
    IMPORT_MISSING_MEMBERS: 'Uvezi nedostajuće članove',
    IMPORT_VALUES: 'Uvezi vrijednosti',
    NO_COLUMN_SET_AS_TABLE: 'Nema stupca postavljenog kao dimenzija',
    NO_COLUMN_SET_AS_VALUE: 'Nema stupca postavljenog kao vrijednost',
    MISSING_MEMBERS: 'Nedostaju članovi dimenzije',
    SELECT_ALL: 'Odaberi sve',
    DESCRIPTION_COLUMN: 'Stupac s opisom',
    CONNECTED_DIMENSIONS_COLUMN: 'Povezani dimenzije stupac',
    CANCEL: 'Otkaži',
    CONTINUE: 'Nastavi',
    CREATE_DIMENSIONS: 'Kreiraj dimenzije',
    SELECT_CONNECTION: 'Odaberi konekciju',
    CLOSE: 'Zatvori',
    SAVE: 'Spremi',
    DELETE: 'Obriši',
    REMOVE: 'Ukloni',
    DELETING_ASSIGNMENT: 'Brisanje zadatka {multiple} ...',
    DELETED_ASSIGNMENT: 'Zadatak {multiple} je obrisan!',
    FAILED_DELETE_ASSIGNMENT: 'Brisanje zadatka {multiple} nije uspjelo',
    DELETE_ASSIGNMENT: 'Obriši zadatak {multiple}',
    DELETE_ASSIGNMENT_CONFIRMATION: 'Želite li izbrisati odabrani zadatak {multiple}?',
    COLUMNS: 'Stupci',
    FORMATTING: 'Formatiranje',
    PRESERVE_FORMATTING: 'Zadrži formatiranje',
    CUSTOM_FORMATTING: 'Prilagođeno formatiranje',
    GROUP_OUTLIERS: 'Grupiraj odstupanja',
    VERSIONS: 'Verzije',
    NONE_VERSION: 'Nijedan',
    APPLY_TO_ALL_YEARS: 'Primijeni na sve godine',
    SHEET_OPTIONS: 'Opcije radnog lista',
    DASHBOARD_OPTIONS: 'Opcije nadzordne ploče',
    LOCK_GRID: 'Zaključaj mrežu',
    RESPONSIVE_LAYOUT: 'Prilagodljivi raspored',
    AUTO_REFRESH_DASHBOARD: 'Automatsko osvježavanje nadzorne ploče',
    REFRESH_DASHBOARD: 'Osvježi nadzornu ploču',
    ONLY_WITH_DATA: 'Samo sa podacima',
    OWD_INCLUDE_MEASURES: 'Uključi mjere',
    STACKED: 'Složeno',
    TIMELINE: 'Vremenska linija',
    RESET_COLUMN_ORDER: 'Poništi redoslijed stupaca',
    STANDARD_COLUMNS_NAME: 'Ime',
    STANDARD_COLUMNS_DESCRIPTION: 'Opis',
    STANDARD_COLUMNS_NAME_PLUS_DESCRIPTION: 'Ime + opis',
    DOWNLOADING_FILE: 'Preuzimanje datoteke',
    FILE_DOWNLOADED: 'Datoteka preuzeta',
    FAIL_FILE_DOWNLOAD: 'Neuspjelo izvoz iz odabrane konfiguracije',
    ADD_TO_DASHBOARD: 'Dodaj na nadzornu ploču',
    COPY_TO_DASHBOARD: 'Kopiraj na nadzornu ploču',
    SUBMIT_ENTRIES_CONFIRMATION: 'Jeste li sigurni da želite poslati unose?',
    FURTHER_CHANGES_AND_LINK_LOCKED_AFTER_SUBMIT: 'Nećete moći vršiti daljnje promjene nakon slanja, a veza će biti zaključana.',
    LINK_NOT_FOUND: 'Veza nije pronađena',
    LINK_EXPIRED: 'Ova veza je istekla',
    DEPLOYMENT: 'Implementacija',
    UNKNOWN: 'Nepoznato',
    FILE_SIZE_10GB: 'Veličina datoteke > 10GB',
    FILE_SIZE_64MB: 'Veličina datoteke > 64MB',
    FILE_SIZE_1MB: 'Veličina datoteke > 1MB',
    FILE_SIZE_TOO_LARGE: 'Veličina datoteke je prevelika',
    UPLOADED: 'Preneseno',
    ERROR_UPLOADING_FILE: 'Greška pri prijenosu datoteke',
    FOLDER_NAME: 'Ime mape',
    NEW_DIMENSION_TABLE: 'Nova dimenzijska tablica',
    NEW_VARIABLE: 'Nova varijabla',
    NEW_DASHBOARD: 'Nova nadzorna ploča',
    NEW_SHEET: 'Novi radni list',
    UPLOAD_FILE: 'Prenesite datoteku',
    NEW_FOLDER: 'Nova mapa',
    NEW_REMOTE_JOB: 'Nova aplikacija',
    DOWNLOAD: 'Preuzimanje',
    DELETE_MENU_ITEM_CONFIRM: 'Jeste li sigurni da želite izbrisati {menuItem}?',
    USER_REMOVED: 'Korisnik je uklonjen!',
    FAILED_USER_REMOVE: 'Brisanje korisnika nije uspjelo',
    USER_DELETING: 'Brisanje korisnika {fullName}',
    USER_DELETING_CONFIRM: 'Jeste li sigurni da želite izbrisati korisnika {fullName}?',
    CONFIRM_DELETE_OPERATION: 'Potvrdi brisanje operacije',
    DELETE_YEAR_CONFIRMATION: 'Jeste li sigurni da želite izbrisati godinu {year}?',
    DELETE_VARIATION_CONFIRMATION: 'Jeste li sigurni da želite izbrisati verziju {name}?',
    YEARS: 'Godine',
    YEAR: 'Godina',
    ADD_YEAR: 'Dodaj {year}',
    OPTIONS: 'Opcije',
    NO_VERSION_SELECTED: 'Nije odabrana verzija',
    INTERVAL_START_GREATER: 'Početak intervala veći od kraja nekih intervala',
    INTERVAL_END_GREATER: 'Kraj intervala manji od nekih početaka intervala',
    INTERVAL_START_GREATED_END: 'Početak intervala veći od kraja',
    NO_NAME_INPUT: 'Zadatak mora imati naziv',
    EDIT_ASSIGNMENTS: 'Uredi zadatke',
    ASSIGNMENT_NAME: 'Naziv zadatka',
    VERSION: 'Verzija',
    ADD_VERSION: 'Dodaj verziju',
    ADD_NEW_VERSION: 'Dodaj novu verziju',
    NEW_VERSION_NAME: 'Naziv nove verzije',
    ERROR_ADDING_VERSION: 'Greška pri dodavanju verzije.',
    NAME_AND_COLOR: 'Ime i boja',
    ADDED_BY: 'Dodano od strane',
    CREATE_SERVICE_USER: 'Kreiraj korisnika usluge',
    CREATE_USER: 'Kreiraj korisnika',
    USER_TYPE: 'Tip korisnika',
    STANDARD: 'STANDARD',
    SERVICE: 'USLUGA',
    CREATED_SERVICE_USER: 'Korisnik usluge kreiran',
    FAILED_CREATE_SERVICE_USER: 'Neuspjelo kreiranje korisnika usluge i API ključa',
    SERVICE_USER_NAME_REQUIRED: 'Naziv korisnika usluge je obavezan',
    CREATED_USER: 'Korisnik kreiran',
    FAILED_CREATE_USER: 'Neuspjelo kreiranje korisnika',
    LAST_NAME_REQUIRED: 'Prezime je obavezno',
    FIRST_NAME_REQUIRED: 'Ime je obavezno',
    EMAIL_REQUIRED: 'Email je obavezan',
    PASSWORD_REQUIRED: 'Lozinka je obavezna',
    PASSWORD_INCORRECT: 'Pogrešna lozinka',
    FIRST_NAME: 'Ime',
    LAST_NAME: 'Prezime',
    EMAIL: 'Email',
    PASSWORD: 'Lozinka',
    CONFIRM_PASSWORD: 'Potvrdi lozinku',
    API_KEY: 'API ključ',
    CREATED_SERVICE_USER_API_KEY: 'API ključ za korisnika usluge {serviceUserName} je kreiran',
    API_KEY_COPIED_TO_CLIPBOARD: 'API ključ je kopiran u međuspremnik',
    CONNECT: 'Poveži se',
    DISCONNECT: 'Odspoji se',
    MIXED_VERSIONS: 'Mješovite verzije',
    MIXED: 'Mješovito',
    USE_RESTRICTIONS: 'Ograniči unos na verzije i intervale',
    ALLOW_ENTRY_ON_PROPERTY_COLUMNS: 'Dopusti unos na stupce svojstava',
    PROPERTY_COLUMNS: 'Stupci svojstava',
    USE_TIME_LIMIT: 'Koristi vremensko ograničenje',
    SELECT_VERSION: 'Odaberite verziju',
    EXPIRES_AFTER: 'Ističe nakon',
    CHANGE: 'Promijeni',
    SMART_FILTER_CHANGE: 'Promjena',
    CHANGES_SUBMITTED: 'Promjene poslane. Čeka se pregled.',
    SUBMITTED: 'Poslano',
    ASSIGNMENTS_AVAILABLE: 'dostupne zadatke',
    SUBMITTING_ASSIGNMENT: 'Podnošenje zadatka',
    SUBMITED_ASSIGNMENT: 'Zadatak je podnet',
    FAIL_SUBMIT_ASSIGNMENT: 'Neuspjelo podnošenje zadatka',
    ASSIGNMENT_LABEL_CREATED: 'Oznaka je kreirana i dodana zadatku',
    SUBMIT_CHANGES: 'Podnijeti promjene?',
    SUBMIT_CHANGES_CONFIRMATION: 'Jeste li sigurni da želite podnijeti svoje promjene? Nećete moći napraviti daljnje izmjene, postupak će biti označen kao spreman za pregled, a vlasnik proračunske tablice će biti obaviješten.',
    CANT_UNDONE_ACTION: 'Ova radnja se ne može poništiti',
    APP_LANGUAGE: 'Jezik aplikacije',
    TARGET_VERSION_SAME_AS_SOURCE_VERSION_ERROR: 'Ciljna verzija ne može biti ista kao izvorna verzija',
    TARGET_VERSION: 'Ciljna verzija',
    SELECT_TARGET_VERSION: 'Molimo odaberite ciljnu verziju',
    SOURCE_VERSION: 'Izvorna verzija',
    SELECT_SOURCE_VERSION: 'Molimo odaberite izvornu verziju',
    ROW_TAGS: 'Oznake reda',
    DELETE_THIS_ROW: 'Izbriši ovaj red',
    SELECT_PARENT_TAG_FOR_MULTIPLE_ROWS_GENERATING: 'Odaberite nadređenu oznaku za generisanje više redova',
    GLOBAL_SEARCH_PLACEHOLDER: 'Pretražite proračunske tablice, nadzorne ploče, tablice baze podataka i varijable',
    NO_RESULTS_FOUND: 'Nema rezultata',
    NEW_TILE: 'Novi element',
    SLICER_STATE_SAVED: 'Slicer stanje spremljeno za sve!',
    INVALID_LINK: 'Neispravan link',
    LINK_NOT_EXIST: 'Link ne postoji',
    ACCESS_NOT_GRANTED: 'Pristup domaćinu nije dozvoljen',
    CONTACT_ADMIN: 'Molimo kontaktirajte svog administratora za više informacija',
    LOGOUT: 'Odjava',
    REGENERATING_LINKS: 'Obnova veza...',
    REGENERATED: 'Obnovljeno!',
    FAILED_REGENERATING_LINKS: 'Neuspjela obnova veza za odabrane javne zadatke',
    REGENERATING_LINKS_SELECTED_ASSIGNMENTS: 'Regenerirati veze za odabrane zadatke?',
    REGENERATING_LINKS_SELECTED_ASSIGNMENTS_CONFIRMATION: 'Jeste li sigurni da želite regenerirati veze za odabrane zadatke? Stari linkovi će postati nevažeći. Ova radnja se ne može poništiti.',
    REGENERATE: 'Obnovi',
    REGENERATE_LINK: 'Obnovi poveznicu',
    SHEET_NOT_FOUND: 'Radni list nije pronađen',
    CLUSTER_NOT_FOUND: 'Klaster nije pronađen',
    PARENT_CLUSTER_NOT_FOUND: 'Nadređeni klaster nije pronađen',
    TAG_NOT_FOUND: 'Oznaka nije pronađena',
    SHEET_ID_NOT_FOUND: 'Radni list nije pronađen',
    FAIL_CREATE_ROW: 'Neuspelo kreiranje reda',
    FAIL_CREATE_CLUSTER: 'Neuspelo kreiranje klastera',
    ROW_CREATED: 'Red kreiran',
    COLUMN_CREATED: 'Stupac kreiran',
    DIMENSION_CREATED: 'Dimenzija kreirana',
    NOT_IMPLEMENTED_YET: 'Još nije implementirano',
    VARIABLE_SHOULD_CONTAIN_ONLY_VARIABLES: 'Polje varijabli bi trebalo sadržavati samo varijable',
    UNKNOWN_ZONE_SINGLE_VALUE: 'Nepoznata zona u jednoj vrednosti',
    FILTER_FIELD_SHOULD_CONTAIN_DIMENSION_TAGS: 'Polje filtera bi trebalo sadržavati oznake dimenzije',
    UNKNOWN_ZONE_DATA_EDITOR: 'Nepoznata zona u editoru podataka',
    VARIABLE_FILED_SHOULD_CONTAIN_ACCOUNT_TAG: 'Polje varijabli bi trebalo sadržavati oznake računa',
    CUSTOM_COLUMN_NOT_FOUND: 'Prilagođeni stupac nije pronađen',
    CANT_ADD_TO_COLUMN: 'Ne mogu dodati {tagType} u tip kolone {columnType}',
    TAG_ALREADY_ADDED: 'Ova oznaka je već dodana',
    MODEL_IMPORT_IN_PROGRESS: 'Uvoz modela je u tijeku...',
    MODEL_IMPORT_SUCCESS: 'Model je uspješno uvezen.',
    CODE_EDITOR_ALLOW_CHANGES: 'Dopustite uređivaču koda da napravi promjene u modelu:',
    ALLOW_ALL: 'Dopusti sve',
    DELETE_MEMBER_ROWS: 'Obriši redove',
    DELETE_TABLES: 'Obriši dimenzijske tablice',
    DELETE_VARIABLES: 'Obriši varijable',
    DELETE_COLUMNS: 'Obriši stupce',
    DELETE_CELLS: 'Obriši ćelije',
    DELETE_EVERYTHING: 'Obriši sve pri primjeni promjena',
    DRY_RUN: 'Suho pokretanje',
    MODEL_CODE_EDITOR: 'Uređivač koda modela',
    MODEL_IMPORT_EXPORT: 'Uvoz/Izvoz modela',
    MODEL_IMPORT: 'Uvoz modela',
    MODEL_EXPORT: 'Izvoz modela',
    MODEL_USE_IN_EXPORT: 'Koristi u izvozu',
    MODEL_OBJECT_TYPE: {
        DTAB: 'Dimenzijske tablice',
        DMEM: 'Članovi dimenzija',
        VAR: 'Varijable',
        CELL: 'Ćelije',
    },
    LOADING: 'Učitavanje...',
    CHAT_STATUS_ANALYZING_CONTEXT: 'Analiziranje vašeg pitanja',
    CHAT_STATS_ACTIONS: '{count} {{radnja|radnje}}',
    CHAT_STATS_CONTEXT: '{tokens} kontekst',
    CHAT_STATS_DURATION_TOOLTIP: 'Koliko je vremena trebalo za generiranje ovog odgovora',
    CHAT_STATS_ACTIONS_TOOLTIP: 'Koliko je radnji agent izvršio (učitavanje vještina, pokretanje koda)',
    CHAT_STATS_CONTEXT_TOOLTIP: 'Trenutna veličina konteksta razgovora. Starije poruke se sažimaju kada postane prevelik.',
    CHAT_DEFAULT_TITLE: 'Razgovor',
    CHAT_ENTER_FULLSCREEN: 'Prikaz preko cijelog zaslona',
    CHAT_EXIT_FULLSCREEN: 'Izlaz iz prikaza preko cijelog zaslona',
    CHAT_RENAME: 'Preimenuj razgovor',
    CHAT_DELETE: 'Obriši razgovor',
    CHAT_CREATE_NEW: 'Stvori novi razgovor',
    CHAT_MESSAGE_PLACEHOLDER: 'Poruka za FarseerAI...',
    CHAT_SEND: 'Pošalji',
    CHAT_RENAME_TITLE: 'Preimenuj razgovor',
    CHAT_HELP_QUESTION: 'Kako vam mogu pomoći danas',
    CHAT_SUGGESTED: 'Predloženo',
    CHAT_GENERATING_SUGGESTIONS: 'Prilagođavanje prijedloga vašem modelu…',
    CHAT_SUGGESTED_SUMMARY: 'Daj mi kratki sažetak modela',
    CHAT_SUGGESTED_VARIANCE: 'Koje je najveće odstupanje između ostvarenja i plana ove godine i zašto?',
    CHAT_SUGGESTED_DRIVERS: 'Raščlani što pokreće moje rezultate u ovom kvartalu',
    CHAT_SUGGESTED_DASHBOARD: 'Izradi nadzornu ploču s rukovoditeljskim pregledom za ovaj model',
    CHAT_SUGGESTED_PNL_DASHBOARD: 'Izradi P&L nadzornu ploču koja uspoređuje ostvarenje s planom',
    CHAT_SUGGESTED_APPS: 'Što mogu pokrenuti odavde? Prikaži moje dostupne aplikacije',
    CHAT_SUGGESTED_RANKING: 'Prikaži mi moje najbolje i najslabije izvođače ove godine',
    CHAT_CREATED: 'Razgovor stvoren!',
    CHAT_CREATED_NEW: 'Novi razgovor stvoren!',
    CHAT_RENAMED: 'Razgovor preimenovan!',
    CHAT_DELETED: 'Razgovor obrisan!',
    CHAT_FAILED_CREATE: 'Nije uspjelo stvoriti novi razgovor.',
    CHAT_FAILED_LOAD: 'Nije uspjelo učitati razgovore.',
    CHAT_FAILED_RENAME: 'Nije uspjelo preimenovati razgovor.',
    CHAT_FAILED_DELETE: 'Nije uspjelo obrisati razgovor.',
    CHAT_FAILED_CANCEL: 'Nije uspjelo otkazati zahtjev.',
    CHAT_FEEDBACK_FAILED: 'Spremanje povratnih informacija nije uspjelo.',
    CHAT_FEEDBACK_THUMBS_UP: 'Dobar odgovor',
    CHAT_FEEDBACK_THUMBS_DOWN: 'Loš odgovor',
    CHAT_FEEDBACK_COMMENT_TITLE: 'Recite nam što je pošlo po zlu',
    CHAT_FEEDBACK_COMMENT_PLACEHOLDER: 'Što je bilo korisno ili što je pošlo po zlu? (neobavezno)',
    CHAT_FEEDBACK_COMMENT_SAVE: 'Spremi',
    CHAT_FEEDBACK_CLEAR: 'Očisti povratne informacije',
    CHAT_AGENT_TYPE_ANALYST: 'Analitičar',
    ADVANCED_SETTINGS: 'Napredne postavke',
    INVALID_JSON_ERROR: 'Neispravan JSON: {message}',
    MAINTENANCE_MODE_CURRENTLY_ENABLED: 'Način održavanja je trenutno omogućen',
    MAINTENANCE_MODE_ENABLED: 'Način održavanja trenutno je omogućen',
    CONTACT_ADMIN_FOR_INFO: 'Molimo sačekajte ili kontaktirajte svog administratora za više informacija.',
    RETRY: 'Pokušaj ponovno',
    OTHER_WORKSPACES_AVAILABLE: 'Prebaci se na radni prostor kojem možeš pristupiti:',
    COPY_LINK: 'Kopiraj poveznicu',
    COPY_DATA_FROM: 'Kopiraj podatke iz',
    ROWS_CUT: 'Redovi izrezani',
    ROWS_COPIED: 'Redovi kopirani',
    ROWS_MOVED: 'Redovi pomaknuti',
    ROWS_PASTED: 'Redovi zalijepljeni',
    CELLS_CUT: 'Ćelije izrezane',
    CELLS_COPIED: 'Ćelije kopirane',
    CELLS_COPIED_FROM: 'Ćelije kopirane iz "{label}"',
    FAILED_CELLS_COPIED: 'Neuspjelo kopiranje ćelija {message}',
    CANNOT_CELLS_PASTED: 'Ne može se zalijepiti ćelije ovdje',
    NAMED_COPY: '{name} (kopija)',
    TAG: 'Oznaka',
    ACTION: 'Akcija',
    MANAGE_CONNECTIONS_FOR: 'Upravljaj vezama za',
    RENAME: 'Preimenuj',
    RENAME_FILE_EXTENSION_REQUIRED: 'Nazivi datoteka moraju imati ekstenziju, poput .csv ili .xlsx.',
    RENAME_FILE_EXTENSION_CHANGE_TITLE: 'Promijeniti ekstenziju datoteke?',
    RENAME_FILE_EXTENSION_CHANGE_QUESTION: 'Ovo mijenja ekstenziju iz “.{oldExt}” u “.{newExt}”, što može promijeniti način otvaranja datoteke. Nastaviti?',
    REMOVE_COLUMN: 'Ukloni stupac',
    REMOVE_CONNECTION: 'Ukloni vezu',
    TABLE_CONNECTION: 'Vezivanje tablica',
    TEXT: 'Tekst',
    TEXT_COLUMN: 'Tekst stupac',
    NUMBER: 'Broj',
    NUMBER_COLUMN: 'Broj stupac',
    NEW_NUMBER_COLUMN: 'Novi broj stupac',
    FILE: 'Datoteka',
    FILE_COLUMN: 'Datoteka stupac',
    DATE_COLUMN: 'Datum stupac',
    EDIT_TAG_TYPE: 'Uredi {tagTypeName}',
    DELETE_TAG_TYPE: 'Obriši {tagTypeName}',
    DELETE_TAG_TYPE_DATA: 'Obriši podatke {tagTypeName}',
    CONNECTIONS: 'Veze',
    EDIT_CONNECTIONS: 'Uredi veze',
    CLEAR_FIELD: 'Očisti polje',
    ERROR_CLEAR_FIELD: 'Greška pri čišćenju polja',
    REPLACE_FILE: 'Zamijeni datoteku',
    DOWNLOAD_FILE: 'Preuzmi datoteku',
    DOWNLOAD_ORIGINAL_FILE: 'Preuzmi originalnu datoteku',
    FILE_DOES_NOT_EXIST: 'Datoteka ne postoji',
    DELETE_FILE: 'Obriši datoteku',
    ERROR_DELETE_FILE: 'Greška pri brisanju datoteke',
    LOCKS: 'Zaključavanje',
    YEARS_VERSIONS_MONTHS: 'Godine / Verzije / Mjeseci',
    CUSTOM_LOCK_RULES: 'Prilagođena pravila zaključavanja',
    STANDARD_LOCK_RULES: 'Standardna pravila zaključavanja',
    LOCK_RULES_WILL_BE_CONVERTED_TO_STANDARD: '{{1 pravilo zaključavanja|?? pravila zaključavanja}} primijenit će se na tablicu Godine / Verzije / Mjeseci',
    LOCK_WILL_BE_CONVERTED_TO_STANDARD: 'Ovo pravilo zaključavanja primijenit će se na gornju tablicu Godine / Verzije / Mjeseci',
    NO_CUSTOM_LOCKS_DEFINED: 'Nisu definirana prilagođena pravila zaključavanja',
    LOCK_REFERENCES_DELETED_ENTITIES: 'Ovo zaključavanje referencira obrisane entitete',
    TABLE_SETTINGS: 'Postavke tablice',
    NEW_MEMBER: 'Novi član',
    SORT_TABLE: 'Sortiraj tablicu',
    LOCK_TABLE: 'Zaključaj tablicu',
    UNLOCK_TABLE: 'Otključaj tablicu',
    TABLE_LOCKED_TOOLTIP: 'Ova tablica je zaključana',
    UNLOCK_SYSTEM_TABLE_TITLE: 'Otključaj sistemsku tablicu',
    UNLOCK_SYSTEM_TABLE_WARNING: 'Ovo je sistemska tablica. Otključavanje može utjecati na integritet modela. Jeste li sigurni da je želite otključati?',
    ERROR_LOCKING_TABLE: 'Greška prilikom zaključavanja tablice.',
    ERROR_UNLOCKING_TABLE: 'Greška prilikom otključavanja tablice.',
    NAME_ASCENDING: 'Po imenu uzlazno',
    NAME_DESCENDING: 'Po imenu silazno',
    ADD_SORT_RULE: 'Dodaj pravilo sortiranja',
    REMOVE_ALL_SORT_RULES: 'Ukloni sva pravila sortiranja',
    '1_SORT': '1 sortiranje',
    N_SORTS: '{count} sortiranja',
    DESCRIPTION_ASCENDING: 'Po opisu uzlazno',
    DESCRIPTION_DESCENDING: 'Po opisu silazno',
    SORTING_DIMENSIONS: 'Sortiranje dimenzija...',
    DIMENSIONS_SORTED: 'Dimenzije sortirane!',
    ERROR_SORTING_DIMENSIONS: 'Greška prilikom sortiranja dimenzija.',
    EDITING_TIMELINE_SLICER: 'Uređivanje slicera {title}',
    CREATE_NEW_TIMELINE_SLICER: 'Kreiraj novi slicer',
    INTERVAL_START: 'Početak intervala',
    INTERVAL_END: 'Kraj intervala',
    FORMAT: 'Format',
    OPERATION: 'Operacija',
    MY_PROFILE_INFORMATION: 'Informacije o mom profilu',
    PROFILE_SETTINGS: 'Postavke profila',
    ADD_PHOTO: 'Dodaj fotografiju',
    CHANGE_PHOTO: 'Promijeni fotografiju',
    UPDATE_PHOTO: 'Ažuriraj fotografiju',
    REMOVE_PHOTO: 'Ukloni fotografiju',
    DECIMAL_SEPARATOR: 'Decimalni separator',
    DATE_FORMAT: 'Format datuma',
    DATE_SEPARATOR: 'Separator datuma',
    ACCESSIBLE_CHART_PATTERNS: 'Uzorci pristupačnosti za grafikone',
    SET_AS_DEFAULT_PALETTE: 'Postavi kao zadanu paletu',
    SAVE_CURRENT_COLORS_AS_PALETTE: 'Spremi trenutne boje kao paletu',
    DELETE_PALETTE: 'Obriši paletu',
    FILL_STYLE: 'Stil ispune',
    SOLID: 'Puno',
    HATCHED: 'Šrafirano',
    VARIABLE: 'Varijabla',
    DIMENSION: 'Dimenzija',
    CREATE_OR_GENERATE_NEW_ROWS: 'Kreiraj ili generiraj nove redove',
    CREATE_ROW_AS: 'Kreiraj {row} kao',
    GENERATE_ROWS_FROM: 'Generiraj red(ove) iz',
    CREATE_NEW_VARIABLE: 'Kreiraj novu varijablu',
    ENTER_FORMULA_FOR: 'Unesite formulu za {variableName}',
    SELECT_A_VARIABLE_FORMULA: 'Odaberite varijablu za pregled ili izmjenu formule',
    DATABASE_AND_PROPERTIES: 'Baza podataka i svojstva',
    FOLDER_EMPTY: 'Mapa je prazna',
    DASHBOARD_EMPTY: 'Ploča je prazna',
    DASHBOARD_HINT: 'Počnite s vašim nadzornim pločama stvaranjem elementa.',
    YEARS_SETTINGS: 'Postavke godina',
    FINANCIAL_YEAR_STARTING_MONTH: 'Početak financijske godine mjesec',
    UPDATING_FINANCIAL_YEAR_STARTING_MONTH: 'Ažuriranje početnog mjeseca financijske godine',
    FINANCIAL_YEAR_STARTING_MONTH_UPDATED: 'Početni mjesec financijske godine ažuriran',
    SOMETHING_WENT_WRONG: 'Došlo je do pogreške.',
    SEARCH_FOR_USERS: 'Pretraži korisnike...',
    SEARCH_FOR_GROUPS: 'Pretraži grupe...',
    SEARCH_BY_GROUP_OR_USER: 'Pretraži po grupi ili korisniku',
    USERS: 'Korisnici',
    GROUPS: 'Grupe',
    USER_OR_GROUP: 'Korisnik/Grupa',
    PERMISSIONS: 'Dozvole',
    END_DATE_MUST_BE_GREATER_THAN_START_DATE: 'Krajnji datum mora biti veći od početnog datuma',
    HISTORY_DATA_CANNOT_OVERLAP_WITH_FORECAST_DATA: 'Povijesni podaci ne mogu se preklapati s podacima prognoze',
    PLEASE_CHOOSE_AN_ACCOUNT_TAG: 'Molimo odaberite oznaku računa',
    ERROR_STARTING_FORECAST: 'Greška pri pokretanju prognoze',
    CUSTOM_FORECAST: 'Prilagođena prognoza',
    HISTORICAL_DATA_FROM: 'Povijesni podaci od',
    HISTORICAL_DATA_TO: 'Povijesni podaci do',
    SOURCE_VARIABLE_AND_DIMENSIONS: 'Izvor varijabla i dimenzije',
    ERROR: 'Greška {message}',
    FORECAST: 'Prognoza',
    VIEW_FORECASTS_FOR_PERIOD: 'Pregledaj prognoze za razdoblje',
    NO_JOBS_FOR_SELECTED_PERIOD: 'Nema poslova za odabrano razdoblje',
    ACTIVE_JOBS: 'Aktivni poslovi',
    FINISHED_JOBS: 'Dovršeni poslovi',
    COMPLETED_ON: 'Završeno {time}',
    FORECAST_PROGRESS: 'Napredak prognoze',
    ERROR_LOADING_FORECAST_JOBS: 'Greška pri učitavanju poslova prognoze.',
    PAGE: 'Stranica',
    EDIT_ENTRY: 'Uredi unos',
    NEW_ENTRY_BY_DATE: 'Novi unos po datumu',
    TAGS: 'Oznake',
    ADD_TAG: 'Dodaj oznaku',
    START_YEAR: 'Početna godina',
    START_MONTH: 'Početni mjesec',
    END_YEAR: 'Završna godina',
    END_MONTH: 'Završni mjesec',
    MUST_SELECT_ROW: 'Morate odabrati red',
    TITLE: 'Naslov',
    SUBTITLE: 'Podnaslov',
    FOOTNOTES: 'Fusnote',
    ROW: 'Red',
    SELECT_ROW: 'Odaberi red',
    COLUMN: 'Stupac',
    ROW_NAME_DISPLAY: 'Prikaz imena reda',
    BOTH: 'Oboje',
    SHARED_COLUMN_CONFIG_PRESET: 'Predložak zajedničke konfiguracije stupca',
    SHOW_ZERO_SUM_ROWS: 'Prikaz nula sumiranih redova',
    USE_DATA_FROM_TIMELINE_SLICER: 'Koristi podatke iz vremenskog slicera',
    USE_DATA_FROM_DIMENSION_SLICER: 'Koristi podatke iz slicera dimenzija',
    DELETE_TARGET_AND_RELATED_DATA: 'i povezani podaci?',
    DELETE_TARGET_CHILDREN: 'Izbriši potomke',
    DELETE_TARGET_DATA: 'Obriši podatke za',
    CONFIRM_DELETE_ROW: 'Izbrisati red?',
    CONFIRM_DELETE_ROWS: 'Izbrisati {count} redova?',
    CONFIRM_DELETE_ROWS_GENERATED: 'Izbrisati generisane redove?',
    CONFIRM_DELETE_ROWS_MIXED: 'Izbrisati redove i generisane redove?',
    EXPLAIN_DELETE_ROW: 'Ovo će izbrisati <>{row}<>',
    EXPLAIN_DELETE_ROWS_GENERATED: 'Ovo će izbrisati generirane redove iz <>{table}<> iz ove proračunske tablice.',
    EXPLAIN_DELETE_ROWS_MIXED: 'Ovo će izbrisati <>{count} red(ova)<> i generirane redove iz <>{table}<> iz ove proračunske tablice.',
    EXPLAIN_DELETE_ROWS_SUBROWS: 'Ovo će također izbrisati sve podredne redove. Ova radnja se ne može poništiti.',
    FAILED_DELETE_ROW: 'Brisanje reda nije uspjelo',
    DELETE_ROW_AND_ITS_CHILDREN_CONFIRMATION: 'i sve njegove podredne redove i stavke?',
    NO_ACCESS_TO_DELETE_ROWS: 'Nemate pristup navedenim redovima, pa ih ne možete izbrisati.',
    CREATE_GROUP: 'Kreiraj grupu',
    EDIT_PERMISSIONS: 'Uredi dozvole',
    USERS_AND_GROUPS_MANAGEMENT: 'Upravljanje korisnicima i grupama',
    SUM: 'Zbroj',
    COUNT: 'Broj',
    AVERAGE: 'Prosječno',
    CLOSING_STATE: 'Završno stanje',
    BEGINNING_STATE: 'Početno stanje',
    FORMULA: 'Formula',
    MAX: 'Maksimum',
    MIN: 'Minimum',
    YES: 'Da',
    NO: 'Ne',
    YESTERDAY: 'Jučer',
    CONFIRM_VARIABLE_REMOVE: 'Potvrdite uklanjanje varijable',
    CONFIRM_VARIABLES_REMOVE: 'Potvrdite uklanjanje varijabli',
    REMOVE_VARIABLE_CONFIRMATION: 'Jeste li sigurni da želite ukloniti varijablu',
    REMOVE_VARIABLES_CONFIRMATION: 'Jeste li sigurni da želite ukloniti varijable',
    REMOVE_VARIABLES_COUNT_CONFIRMATION: 'Jeste li sigurni da želite ukloniti {tagNumber} varijabli?',
    EDIT_VARIABLE: 'Uredi varijablu',
    SHARE_VARIABLE: 'Podijeli varijablu',
    DELETE_VARIABLE_DATA: 'Izbriši podatke varijable',
    DELETE_VARIABLE: 'Izbriši varijablu',
    EXPAND_MORE: 'Proširi više',
    COLLAPSE_ALL: 'Skupi sve',
    SCROLL_TO_BOTTOM: 'Pomakni se na dno',
    VARIABLE_METRICS: 'Metrike varijable',
    VARIABLE_TABLE_COLUMNS: {
        Name: 'Ime',
        Description: 'Opis',
        Formula: 'Formula',
        Dimensions: 'Dimenzije',
        'Read-only': 'Samo za čitanje',
        'Roll-up type': 'Tip uvrštavanja',
    },
    LOADING_DATA: 'Učitavanje podataka…',
    SUCCESSFULLY_LOADED_DATA: 'Podaci učitani',
    LOADING_DATA_FAILED: 'Nije moguće učitati podatke',
    LOADING_DATA_FAILED_SUBTITLE: 'Pokušajte osvježiti stranicu',
    WAITING: 'Čekanje...',
    VIEW_LOGS: 'Pogledaj zapise',
    LOADING_DATA_LOG: 'Zapisnik učitavanja podataka',
    CALCULATION_STARTED: 'Početak izračunavanja',
    CALCULATION_FINISHED: 'Izračunavanje završeno',
    DATABASE_LOADED: 'Baza podataka učitana. Broj učitanih ćelija: {numberOfCells}',
    VARIABLE_CALCULATION_STARTED: 'Počelo izračunavanje varijable {variableName}. Broj ulaznih ćelija: {numberOfCells}',
    VARIABLE_CALCULATION_ENDED: 'Izračunavanje varijable {variableName} završeno. Broj ćelija: {numberOfCells}, faktor izlaz/ulaz: {outInFactor}.',
    NEW_ROW: 'Novi red',
    NEW_TEMPLATE_OR_ROW: 'Novi',
    ADD_TEMPLATE_TO_TOOLBAR: 'Dodaj u alatnu traku',
    REMOVE_TEMPLATE_FROM_TOOLBAR: 'Ukloni iz alatne trake',
    IN_TOOLBAR: 'U alatnoj traci',
    TEMPLATE_ADDED_TO_TOOLBAR: 'Predložak dodan u alatnu traku',
    TEMPLATES: 'Predlošci',
    SELECT_A_ROW: 'Odaberi red',
    FILE_CANT_BE_PREVIEWED: 'Datoteka se ne može pregledati',
    THIS_TYPE_OF: 'Ovaj tip',
    INPUT_SETUP: 'Postavke ulaza',
    ONDEMAND_CALCULATION: 'Proračun po zahtjevu',
    REFRESH_DATA: 'Osvježi podatke',
    DISABLE_MAINTENANCE_MODE: 'Onemogući režim održavanja',
    ENABLE_MAINTENANCE_MODE: 'Omogući režim održavanja',
    SAVED: 'Spremljeno',
    FORMULA_ERROR: 'Greška u formuli',
    UNEXPECTED: 'Neočekivano',
    INVALID_SYNTAX: 'Neispravna sintaksa za',
    MISSING_TOKEN_AFTER: 'Nedostaje token nakon',
    UNNECESSARY: 'Nepotrebno',
    ERROR_MESSAGE_OCCURRED: 'Došlo je do greške',
    INCOMPLETE_sheet_ITEM_DATA: 'Nepotpuni podaci o stavkama',
    FAIL_SAVE_sheet_ITEMS: 'Neuspjelo spremanje stavki',
    HEADER_COLUMNS: {
        Description: 'Opis',
        Date: 'Datum',
        Version: 'Verzija',
        'Variable and Dimensions': 'Varijabla i dimenzije',
        Value: 'Vrijednost',
        'Value type': 'Vrsta vrijednosti',
        Action: 'Akcija',
    },
    DESCRIPTION_UPDATE_DATE_TAGS_FAILED: 'Ažuriranje opisa za oznake za mjesec i godinu nije uspjelo.',
    COMPARISON: 'Usporedba',
    DISALLOW: 'Onemogući',
    USE_DEFAULT: 'Koristi zadanu',
    SKIP_ROW: 'Preskoči red',
    MISSING_MEMBERS_IMPORT_NOT_ALLOWED: 'Neće dopustiti uvoz dok postoje nepostojeći članovi.',
    MISSING_MEMBERS_SKIP_ROWS: 'Preskoči redove s nepostojećim članovima.',
    MISSING_MEMBERS_DEFAULT: 'Uvozit će podatke s nepostojećih članova u zadani član tabele.',
    CONFIGURE_JOB_OPTIONS: 'Konfiguriraj opcije posla',
    HANDLE_MISSING_DIMENSION_MEMBERS: 'Upravljaj nedostajućim članovima dimenzije',
    IMPORT_ZEROS: 'Uvezi nule',
    OVERWRITE_CELLS: 'Prepisi ćelije',
    IGNORE_FINANCIAL_YEAR_OFFSET: 'Ignoriraj pomak financijske godine',
    SKIP_EMPTY_ROWS: 'Preskoči prazne retke',
    SKIP_REPEATING_HEADER_ROWS: 'Preskoči ponavljajuće retke zaglavlja',
    SKIP_LOW_SIGNAL_ROWS_HEURISTIC: 'Preskoči retke s malo informacija (heuristika)',
    ROWS_WILL_BE_SKIPPED_ON_IMPORT: '{count} red(ova) bit će preskočeno pri uvozu.',
    NO_ROWS_WILL_BE_SKIPPED_ON_IMPORT: 'Nijedan red neće biti preskočen pri uvozu.',
    INCLUDE_IN_IMPORT: 'Uključi u uvoz',
    EXCLUDE_FROM_IMPORT: 'Isključi iz uvoza',
    MISSING_MEMBERS_REPLACE_ALL: 'Zamijeni sve prethodne članove dimenzije',
    MISSING_MEMBERS_REPLACE_ALL_CONFIRMATION: 'Jeste li sigurni da želite zamijeniti sve prethodne članove dimenzije?',
    APPLY_MEMBERS_AND_VARIABLES_TO_VALUE_COLUMNS: 'Primijeni članove i varijable na vrijednosne stupce',
    WRONG_RESULT_TYPE_FOR_COLUMN: 'Dobiven je pogrešan tip rezultata za stupac {columnKey}',
    TRIED_TO_ADD_NON_UNIQUE_TAGS: 'Pokušano je dodavanje nejedinstvenih oznaka',
    TRIED_TO_CREATE_TAG_WITH_EMPTY_NAME: 'Pokušano je stvaranje oznake s praznim imenom',
    NO_PARENT_TAG_SELECTED: 'Nije odabran roditeljski tag',
    COLUMN_MANAGER: 'Stupci',
    NO_COLUMNS: 'Nema stupaca.',
    NEW_COLUMN_TIP: 'Možete početi dodavanjem novog elementa stupca. Zatim koristite bočnu traku za odabir i kreiranje prilagođenih stupaca.',
    NEW_COLUMN: 'Novi stupac',
    COLUMN_TO_NUMBER_TYPE: 'Promijeni u broj',
    COLUMN_TO_COMPARISON_TYPE: 'Promijeni u usporedbu',
    COMPARISON_OPERATION: 'Operacija',
    DROP_ELEMENTS: 'Odbaci elemente...',
    READONLY: 'Samo za čitanje',
    CUSTOM_TITLE: 'Prilagođeni naslov',
    SELECT_ROW_TO_DROP_ELEMENTS: 'Odaberite red za odbacivanje elemenata',
    CANT_MOVE_ROW_INSIDE_SELF: 'Ne možete premjestiti red unutar samog sebe',
    CLEAR_ALL: 'Obriši sve',
    MIGRATE_TO_SHEET: 'Migriraj na radni list',
    CHOOSE_TIME_PERIOD: 'Odaberite vremenski period',
    NO_VARIABLE: 'Nema varijable',
    NO_ROWS_SELECTED: 'Nema odabranih redova',
    STARTING_YEAR_NOT_ACTIVE: 'Početna godina nije aktivna',
    SHEET: 'Radni list',
    ASSIGNEE: 'Dodijeljeni',
    APPROVER: 'Odobravatelj',
    SHARED_TO: 'Dijeljeno s',
    PUBLIC: 'Javno',
    PUBLIC_LINK: 'Javna poveznica',
    VERSIONS_AND_INTERVAL: 'Verzije i interval',
    INTERVAL: 'Interval',
    EXPIRES_IN: 'Ističe za',
    STATUS: 'Status',
    STATUS_EXPIRES_IN: 'Status (Ističe za)',
    PUBLIC_ASSIGNMENT_LINK_COPIED_TO_CLIPBOARD: 'Veza javnog zadatka kopirana u međuspremnik',
    EXPORTING: 'Izvoz...',
    APPROVE: 'Odobri',
    DISAPPROVE: 'Odbij',
    EXPORT: 'Izvezi',
    EXPIRE: 'Istekni',
    REFRESH: 'Osvježi',
    NO_ASSIGNMENTS_AVAILABLE: 'Nema dostupnih zadataka',
    MARK_IN_REVIEW: 'Označi kao u pregledu',
    MARK_AS_UNRESOLVED: 'Označi kao neriješeno',
    MARK_AS_RESOLVED: 'Označi kao riješeno',
    GO_TO_ROW: 'Idi na red',
    DELETE_THREAD: 'Izbriši nit',
    REPLAY_OR_TAG_IN_COMMENT: 'Odgovori ili označi druge s @...',
    COMMENT_OF: 'Komentar {arrowsCurrent} od {arrowsAll}',
    COMMENT: 'Komentar',
    COMMENTS: 'Komentari',
    LOADING_IMPORT_JOBS: 'Učitavanje poslova uvoza',
    IMPORT_ROWS_TRUNCATED_WARNING: 'Skup podataka je prevelik za potpuni prikaz. Prikazano je samo prvih 200.000 redova. Svi redovi će biti uvezeni kada potvrdite.',
    SELECTED_JOB_DOESNT_EXIST: 'Odabrani posao ne postoji',
    GO_BACK_TO_IMPORT: 'Vrati se na uvoz',
    BACK_TO_IMPORT: 'Nazad na uvoz',
    AT_LEAST_ONE_CHART_LINE: 'Morate dodati barem jednu liniju grafikona.',
    AT_LEAST_ONE_X_AXIS_TAG: 'Morate dodati barem jednu oznaku osi x',
    VISUALIZATION_TYPE: 'Vrsta vizualizacije',
    VISUALISATION_OPTIONS: 'Opcije vizualizacije',
    EDIT_CHART: 'Uređivanje grafikona "{title}"',
    BAR_CHART: 'Stupčasti grafikon',
    BAR: 'Stupac',
    STACKED_BAR_CHART: 'Složeni stupčasti grafikon',
    STACKED_BAR: 'Složeni stupac',
    WATERFALL_CHART: 'Vodopadni grafikon',
    WATERFALL: 'Vodopad',
    PIN_CHART: 'Pribadača grafikon',
    PIN: 'Pribadača',
    AREA_CHART: 'Plošni grafikon',
    AREA: 'Površina',
    STACKED_AREA_CHART: 'Složeni plošni grafikon',
    STACKED_AREA: 'Složena površina',
    LINE_CHART: 'Linijski grafikon',
    LINE: 'Linija',
    COMBO_CHART: 'Kombinirani grafikon',
    PIE_CHART: 'Tortni grafikon',
    TRAFFIC_LIGHT: 'Semafor',
    INDICATOR: 'Pokazivač',
    SINGLE_VALUE: 'Pojedinačna vrijednost',
    CREATE_CHART: 'Stvori novi grafikon',
    ORIENTATION_LAYOUT: 'Orijentacija i raspored',
    HORIZONTAL: 'Horizontalno',
    VERTICAL: 'Vertikalno',
    SINGLE: 'Pojedinačno',
    GRID: 'Mreža',
    THIN: 'Tanko',
    THICK: 'Debelo',
    DOUBLE: 'Dvostruko',
    DOT: 'Točka',
    CIRCLE: 'Krug',
    SQUARE: 'Kvadrat',
    CATEGORY_AXIS: 'Os kategorija',
    DOMAIN_AXIS: 'Os domene',
    SHOW_TOTALS: 'Prikaži ukupne vrijednosti',
    SHOW_AXIS: 'Prikaži os',
    SHOW_VALUE_AXIS: 'Prikaži os vrijednosti',
    SHOW_CATEGORY_AXIS_LABELS: 'Prikaži oznake osi kategorija',
    COMPACT_AXIS_LABELS: 'Kompaktne oznake osi',
    CATEGORY_LABEL_ANGLE: 'Kut oznake kategorije',
    LABEL_FORMAT: 'Format oznake',
    SHOW_LEGEND: 'Prikaži legendu',
    SHOW_INTEGRATED_LEGEND: 'Prikaži integriranu legendu',
    VALUE_LABELS: 'Oznake vrijednosti',
    ROW_VALUE_LABELS: 'Oznake vrijednosti redova',
    SHOW_VALUE_LABELS: 'Prikaži oznake vrijednosti',
    POSITION: 'Pozicija',
    SMART_FILTERING: 'Pametno filtriranje',
    TRANSPOSE_DATA: 'Koristi stupce kao serije',
    NORMALIZE_TO_PERCENT: 'Normaliziraj na 100%',
    SHOW_EMPTY_ROWS: 'Prikaži prazne redove',
    SHOW_EMPTY_COLUMNS: 'Prikaži prazne stupce',
    GROUP_BY_PARENT_ROW: 'Grupiraj po nadređenom redu',
    ACCUMULATE_DATA: 'Izračunaj tekući zbroj',
    COLOR_BY_VALUE: 'Oboji prema vrijednosti',
    COLOR_BY_TREND: 'Obojaj prema trendu',
    COLOR_TOTALS_BY_VALUE: 'Oboji ukupne vrijednosti prema vrijednosti',
    THRESHOLD_VALUE: 'Vrijednost praga',
    USE_SHARED_SCALE: 'Koristi zajedničku skalu',
    STATIC: 'Statično',
    BY_VALUE: 'Prema vrijednosti',
    BY_TREND: 'Prema trendu',
    BAR_SPACING: 'Razmak stupaca',
    GAP: 'Razmak',
    WIDTH: 'Širina',
    USE_DATA_FROM_DIMENSION_SLICERS: 'Koristi podatke iz slicera dimenzija',
    X_AXIS_DIMENSION_BUILDER: 'Graditelj dimenzija osi X',
    ADD_REMOVE_X_AXIS_COLUMN: 'Dodaj/ukloni stupac osi x',
    Y_AXIS_ITEMS: 'Stavke osi Y',
    ADD_CHART_LINE: 'Dodaj liniju grafikona',
    UNLOCK_HIERARCHY: 'Otključaj hijerarhiju',
    LOCK_HIERARCHY: 'Zaključaj hijerarhiju',
    MATERIALIZE: 'Materijaliziraj',
    MORE_OPTIONS: 'Više opcija',
    LOCK_ROW: 'Zaključaj red',
    LOCK_COLUMN: 'Zaključaj stupac',
    PASTE: 'Zalijepi',
    COPY: 'Kopiraj',
    CUT: 'Izreži',
    PASTE_ROWS: 'Zalijepi red(ove)',
    COPY_ROWS: 'Kopiraj red(ove)',
    CUT_ROWS: 'Izreži red(ove)',
    MOVING_ROWS: 'Premještanje redova...',
    PASTING_ROWS: 'Lijepljenje redova...',
    CONFIRM_LOCK: 'Potvrdi zaključavanje',
    CONFIRM_UNLOCK: 'Potvrdi otključavanje',
    CONFIRM_LOCK_AND_CHILDREN: 'Jeste li sigurni da želite zaključati ovaj red i njegove podredove?',
    CONFIRM_UNLOCK_AND_CHILDREN: 'Jeste li sigurni da želite otključati ovaj red i njegove podredove?',
    SEARCH_FOR_IMPORTS: 'Pretraži uvoze',
    NEW_IMPORT: 'Novi uvoz',
    IMPORTER: 'Uvoznik',
    CREATION_DATE: 'Datum stvaranja',
    ACTIONS: 'Radnje',
    ADD_ACTION: 'Dodaj radnju',
    ADD_ARGUMENT: 'Dodaj argument',
    EDIT_ACTION: 'Uredi radnju',
    ACTION_NAME: 'Naziv radnje',
    ARCHIVE: 'Arhiviraj',
    REPLACE: 'Zamijeni',
    STATUS_MESSAGE_MAP: {
        'In progress': 'U tijeku',
        Commited: 'Započeto',
        Archived: 'Arhivirano',
        Reverted: 'Vraćeno',
    },
    EDIT_TILE: 'Uredi element',
    FOCUS_TILE: 'Fokusiraj element',
    UNFOCUS_TILE: 'Poništi fokus elementa',
    MOVE_TO: 'Premjesti u',
    ADD_ROW: 'Dodaj red',
    ADD_COLUMN: 'Dodaj stupac',
    EDIT_ROW: 'Uredi red',
    FROM: 'Od',
    TO: 'Do',
    GLOBAL_FORMATTING: 'Globalno formatiranje',
    FAIL_SAVE_CHANGES: 'Neuspješno spremanje promjena.',
    TAG_NAME_EXISTS: 'Ime oznake već postoji.',
    MUST_CHOOSE_TYPE: 'Morate odabrati vrstu',
    MUST_ENTER_TAG_NAME: 'Morate unijeti ime oznake',
    TAG_NAME_CANT_CONTAIN_QUOTATION_MARKS: 'Ime oznake ne može sadržavati navodnike.',
    INVALID_VARIABLE_TAG_FORMAT: 'Nevažeći format oznake varijable: {tagFormat}',
    INVALID_FORMULA: 'Nevažeća formula.',
    FUNCITON_NOT_ALLOWED_ON_DIMENSION_TAGS: 'Funkcija {image} nije dopuštena na oznakama dimenzija.',
    CREATE_DATABASE_OBJECT: 'Kreiraj objekt baze podataka',
    EDIT_TAG_TYPE_NAME: 'Uredi {tagType} "{tagName}"',
    PARENT: 'Roditelj',
    ROOT: 'Korijen',
    SEARCH_OR_SELECT_PARENT_TAG: 'Pretraži ili odaberi oznaku roditelja',
    ROLLUP_TYPE: 'Tip sabiranja',
    DATA_TYPE: 'Tip podataka',
    FORMAT_TYPE: 'Tip formata',
    CHOOSE_FORMATTING_OPTION: 'Odaberite opciju formatiranja',
    ENTER_CUSTOM_FORMAT: 'Unesite prilagođeni format',
    CUSTOM_FORMAT: 'Prilagođeni format',
    TOP_DOWN: 'Top down',
    TOP_DOWN_DATA_MAPPING: 'Top down mapiranje podataka',
    CONNECTED: 'Povezan',
    ADD_CONNECTED_VARIABLE: 'Dodaj povezanu varijablu',
    REVERSE_CONNECTED: 'Obrnuto povezano',
    ADD_REVERSE_CONNECTED_VARIABLE: 'Dodaj obrnuto povezanu varijablu',
    DIMENSIONS: 'Dimenzije',
    ADD_DIMENSION: 'Dodaj dimenziju',
    ADVANCED: 'Napredno',
    CALCULATE_ON_DEMAND: 'Izračunaj po zahtjevu',
    TRIGGER_ON_DEMAND_CALCULATION: 'Za pokretanje izračuna po zahtjevu, idite na "Podešavanje unosa"',
    OPTIMIZE_CALCULATION: 'Optimiziraj izračun',
    CONSTRAINED_LIGHT_TOP_DOWN: 'Ograničeni lagani top down',
    USE_HIERARCHY_IN_CALCULATION: 'Koristi hijerarhiju u izračunu',
    MAPPING_TO_VARIABLE: 'Mapiranje na varijablu',
    ADD_FROM_VERSION: 'Dodaj iz verzije',
    MAPPING_FROM_VERSION: 'Mapiranje iz verzije',
    MAPPING_TO_VERSION: 'Mapiranje na verziju',
    ADD_TO_VERSION: 'Dodaj u verziju',
    USED_IN_FORMULA: 'Koristi se u 1 formuli',
    USED_IN_FORMULAS: 'Koristi se u {numberOfTags} formula',
    TABLE_BACKLINKS: 'Referencirano u {{1 tablici|?? tablica}}',
    VARIABLE_BACKLINKS: 'Korišteno u {{1 varijabli|?? varijabli}}',
    ACTIVE: 'Aktivan',
    CONNECTED_DIMENSION: 'povezanu dimenziju',
    MY_ACCOUNT: 'Moj račun',
    SIGN_OUT: 'Odjava',
    LOG_OUT: 'Odjava',
    EDIT_PROFILE: 'Uredi profil',
    FARSEER_AI: 'FarseerAI',
    FARSEER_LABS: 'Farseer Labs',
    PROFILE_AND_SUPPORT: 'Profil i podrška',
    RENAME_TABLE: 'Preimenuj tablicu',
    SHARE_TABLE: 'Podijeli tablicu',
    DELETE_TABLE_DATA: 'Obriši podatke u tablici',
    DELETE_TABLE_MEMBERS: 'Obriši članove tablice',
    DELETE_TABLE_DIMENSIONS: 'Obriši dimenzije tablice',
    DELETE_TABLE: 'Obriši tablicu',
    DELETE_ROW: 'Obriši redak',
    DELETE_ROWS: 'Obriši red(ove)',
    SHOW_VALUE: 'Prikaz vrijednosti',
    SHOW_VARIABLES_AND_DIMENSIONS: 'Prikaz varijabli i dimenzija',
    FREEZE_PANES: 'Zamrzni okna',
    FREEZE_UP_TO_THIS_ROW: 'Zamrzni do ovog retka',
    FREEZE_UP_TO_THIS_COLUMN: 'Zamrzni do ovog stupca',
    UNFREEZE_ROWS: 'Odzamrzni retke',
    UNFREEZE_COLUMNS: 'Odzamrzni stupce',
    HIDE_GRIDLINES: 'Sakrij mrežne linije',
    HIDE_ROW_COLUMN_HEADERS: 'Sakrij zaglavlja redova/stupaca',
    LABELS: 'Oznake',
    ADD_LABEL: 'Dodaj oznaku',
    ERROR_LABEL_EXISTS: 'Oznaka već postoji!',
    ERROR_RENAMING_IMPORT_JOB_LABEL: 'Greška pri preimenovanju oznake uvoznog posla!',
    IMPORT_JOB_LABEL_RENAMED: 'Oznaka uvoznog posla preimenovana',
    ERROR_DELETING_IMPORT_JOB_LABEL: 'Greška pri brisanju oznake uvoznog posla!',
    IMPORT_JOB_LABEL_DELETED: 'Oznaka uvoznog posla obrisana',
    CREATE_OR_SEARCH: 'Kreiraj ili pretraži..',
    CREATE: 'Kreiraj',
    NAME_AND_DESCRIPTION: 'Naziv i opis',
    SUBTOTALS: 'Sumarne vrednosti',
    TOTAL: 'Ukupno',
    DISABLED: 'Onemogućen',
    BEFORE: 'Prije',
    AFTER: 'Poslije',
    UNSELECT_ALL: 'Poništi odabir',
    SAVE_CONFIG_FOR_ALL: 'Spremi za sve',
    SAVE_CONFIG_FOR_ALL_TOOLTIP: 'Spremi promjene konfiguracije kao zadanu',
    EDIT_DIMENSION_SLICER: 'Uređivanje dimenzionalnog slica "{title}"',
    CREATE_DIMENSION_SLICER: 'Kreiraj novi dimenzionalni slica',
    ENABLE_MULTISELECT: 'Omogući višestruki odabir',
    DISPLAY_MULTIPLE_VALUES: 'Prikaži višestruke vrijednosti',
    SEARCH_AND_AUTO_SELECT: 'Pretraži i automatski odaberi',
    BLANKS: '(Prazno)',
    ENTER_TITLE: 'Unesite naslov...',
    TAG_NAME_DISPLAY: 'Prikaz imena oznake',
    FILTERS: 'Filteri',
    ADD_FILTER: 'Dodaj filter',
    BY_DIMENSION: 'Po dimenzijama',
    SHOW_ONLY_DIMENSIONS_WITH_DATA_IN: 'Prikaz samo dimenzija s podacima',
    EDIT_SINGLE_VALUE: 'Uređivanje pojedinačne vrijednosti "{title}"',
    CREATE_SINGLE_VALUE: 'Kreiraj novu pojedinačnu vrijednost',
    LEAVE_EMPTY_FOR_AUTOGENERATED: 'Ostavi prazno za automatsko generiranje',
    FILTER_DIMENSIONS: 'Filtriraj dimenzije',
    COMPARISON_DIMENSIONS: 'Dimenzije za poređenje',
    COMPARISON_CUSTOM_TEXT: 'Prilagođeni tekst za poređenje',
    DATA_ENTRY: 'Unos podataka',
    SHOW_BUTTONS: 'Prikaz gumba',
    STEP: 'Korak',
    AND: 'i',
    DOWNSTREAM_FILTERS: 'Filtri nizvodno',
    TO_TABLE: 'U tablicu',
    FROM_TABLE: 'Iz tablice',
    ADD_DOWNSTREAM_FILTER: 'Dodaj nizvodni filter',
    FLAT: 'Ravno',
    HIERARCHY_MAX_DEPTH: 'Maksimalna dubina hijerarhije',
    APPLICATION_VERSION: 'Verzija aplikacije',
    CONFIRM_TAG_REMOVE: 'Potvrdi uklanjanje oznake',
    CONFIRM_TAGS_REMOVE: 'Potvrdi uklanjanje oznaka',
    REMOVE_TAG_CONFIRMATION: 'Jeste li sigurni da želite ukloniti oznaku {tagName}?',
    REMOVE_TAGS_CONFIRMATION: 'Jeste li sigurni da želite ukloniti oznake: {tagNames}?',
    REMOVE_TAGS_NUMBER_CONFIRMATION: 'Jeste li sigurni da želite ukloniti {tagNumber} oznaka?',
    ERROR_PARSING_NUMBER: 'Greška pri parsiranju broja',
    ERROR_PARSING_DATE: 'Greška pri parsiranju datuma',
    USE_CONTEXT_MENU_FOR_UPDATING_FILE_COLUMN: 'Koristite kontekstni izbornik za ažuriranje stupca datoteke',
    ERROR_PARSING_INPUT_NUMBER: 'Greška pri parsiranju unosa broja',
    ERROR_SAVING_DATA: 'Greška prilikom čuvanja podataka',
    DATA_ENTRY_NOT_ALLOWED: 'Unos podataka nije dozvoljen',
    ERROR_PARSING_STEP_VALUE: 'Greška pri parsiranju vrednosti koraka',
    TAG_NAME_CELLS: '{tagName}: {cellNumber} ćelija',
    UNKNOWN_VARIABLE_CELLS: 'Nepoznata varijabla: {cellNumber} ćelija',
    SUCCESS_IMPORTED_CELLS: 'Uspješno! Uvezeno ćelija: {accountTags}',
    IMPORTED_CELLS: 'Uvezeno ćelija',
    IMPORT_JOB_DELETING: 'Brisanje uvoznog posla',
    IMPORT_JOB_DELETING_CONFIRM: 'Jeste li sigurni da želite izbrisati uvozni posao {importJobName}?',
    DELETE_AND_KEEP_DATA: 'Izbriši i zadrži podatke',
    DELETE_JOB_AND_DATA: 'Izbriši posao i podatke',
    ADD_DIMENSIONS_TO_JOB: 'Dodaj dimenzije poslu',
    CONFIGURE: 'Konfiguriraj',
    ADD_DESCRIPTION_FOR_IMPORT: 'Dodaj opis za ovaj uvoz',
    UNDO: 'Poništi',
    SETTINGS: 'Postavke',
    BASIC_SETTINGS: 'Osnovne postavke',
    OTHER_SETTINGS: 'Ostale postavke',
    TABLE_NAME: 'Ime tablice',
    AUTOGENERATE_DIMENSION_NAMES: 'Automatsko generiranje imena dimenzija',
    AUTOGENERATE_NAMES_CONFIG: 'Konfiguracija automatskog generiranja imena',
    AUTOGENERATE_NAMES_CONFIG_EXAMPLE: 'npr. {SSS}-{YY}#{DD}',
    CUSTOM_TEMPLATE_DESCRIPTION: 'Definirajte prilagođenu konfiguraciju za automatsko generiranje imena za ovu tablicu. Koristite predefinirane oznake ispod s vitičastim zagradama. Možete staviti bilo koji znak između oznaka.',
    USE_TOKENS_TO_DEFINE_CONFIG: 'Možete koristiti ove oznake za definiranje konfiguracije',
    AUTOGENERATE_CONFIG_EXAMPLE: '{SSS}-{YY}#{MM}_{DD}',
    AUTOGENERATE_CONFIG_EXAMPLE_DATE: '- 001-23#03_20 (ožujka 20, 2023.)',
    ENTRY: 'Unos',
    STEP_MUST_BE_NUMBER: 'Korak mora biti broj',
    EDIT_DATA_EDITOR: 'Uređivanje uređivača podataka "{title}"',
    BUTTON_CONTROLS: 'Kontrole gumbova',
    BOLD: 'Podebljano',
    ITALIC: 'Kurziv',
    UNDERLINED: 'Podcrtano',
    OUTLINED: 'Obrub',
    FONT_SIZE: 'Veličina fonta',
    FILE_SIZE: 'Veličina datoteke',
    SMALL: 'Malo',
    MEDIUM: 'Srednje',
    LARGE: 'Veliko',
    CREATE_NEW_COLUMN: 'Kreiraj novi stupac',
    EDIT_COLUMN_WITH_LABEL: 'Uredi stupac "{label}"',
    COLUMN_TAGS: 'Oznake stupca',
    DELETE_THIS_COLUMN: 'Obriši ovu kolonu',
    SELECT_PARENT_TAG_TO_GENERATE_COLUMNS: 'Izaberite roditeljsku oznaku za generiranje više kolona',
    USING_SHARED_COLUMN_CONFIG: 'Koristi zajedničku konfiguraciju stupca',
    SLICER_GENERATED: 'Slicer generiran',
    HEADER_CANNOT_BE_EMPTY: 'Zaglavlje ne može biti prazno',
    MUST_CHOOSE_A_FORMAT: 'Morate odabrati format',
    CALCULATION_FIELDS_CANT_BE_EMPTY: 'Polja za izračunavanje ne mogu biti prazna',
    ADD_NEW_COLUMN: 'Dodaj novi stupac',
    HEADER: 'Zaglavlje',
    SUBHEADER: 'Podnaslov',
    TYPE: 'Tip',
    POLARITY: 'Polaritet',
    CONDITIONAL_FORMATTING: 'Uvjetno formatiranje',
    CONDITIONAL_FORMATTING_TYPE_OPTIONS: {
        Relative: 'Relativno',
        Absolute: 'Apsolutno',
    },
    CONDITIONAL_FORMATTING_POLARITY_OPTIONS: {
        Positive: 'Pozitivno',
        Negative: 'Negativno',
        Neutral: 'Neutralno',
    },
    KPI_COLUMN_TYPE_META: {
        Regular: 'Regularno',
        Calculated: 'Izračunato',
    },
    CONDITIONAL_FORMATTING_OPTIONS: {
        Off: 'Isključeno',
        Traffic: 'Semafori',
        Databar: 'Traka podataka',
        Colorscale: 'Skala boja',
        Arrows: 'Strelice',
    },
    HIDE_NUMBERS: 'Sakrij brojeve',
    COLUMN_ONE: 'Stupac 1',
    COLUMN_TWO: 'Stupac 2',
    LITERAL: 'literal',
    FUNCTION: 'funkcija',
    FUNCTIONS: 'Funkcije',
    EXAMPLE: 'Primjer',
    EDIT_IN: 'Uredi {type}',
    OPEN_IN_EDITOR: 'Otvori u {type} editor',
    REMOTE_JOBS_DATE_TIME_MESSAGE: 'Svaki tjedan u {day} u {time}',
    REMOTE_JOB_SCHEDULED: 'Zakazano {schedule}',
    SCHEDULE: 'Raspored',
    EVERY: 'Svaki',
    EVERY_HOUR_AT: 'Svaki sat u',
    EVERY_DAY_AT: 'Svaki dan u',
    RUN_JOB: 'Pokreni posao',
    RUN: 'Pokreni',
    QUEUED: 'Na čekanju',
    RUNNING: 'Izvršavanje...',
    UNAVAILABLE: 'Nedostupno',
    MINUTES: 'minute',
    JOBS: 'Poslovi',
    JOB_LOGS: 'Logovi posla',
    PREFERRED_RUNNER: 'Preferirani izvođač',
    RUNNER_DISCONNECTED: 'Ovaj izvođač trenutno nije povezan.',
    RUNNER_IMAGE: 'Slika izvođača',
    RUNNER_IMAGE_TAG: 'Verzija',
    LOGS: 'Logovi',
    REMOTE_JOBS: 'Aplikacije',
    TAG_INTERNAL_TYPE_NAME: {
        Version: 'Verzija',
        Year: 'Godina',
        Month: 'Mjesec',
        Quarter: 'Kvartal',
        'Half Year': 'Polugodište',
        'Year to Date': 'Od početka godine',
    },
    VARIABLE_TABLE_DIMENSION_GROUP: 'Varijabla/Tablica/Dimenzija/Grupa',
    ADD_NEW_VARIABLE_TABLE_DIMENSION_GROUP: 'Dodaj novi {item}',
    DATA_TYPE_ENUM: {
        Integer: 'Cijeli broj',
        Decimal: 'Decimalni',
    },
    DEFAULT_FORMAT_TYPE_ENUM: {
        Custom: 'Prilagođeno',
        Number: 'Broj',
        Currency: 'Valuta',
        Percentage: 'Postotak',
        Date: 'Datum',
    },
    HEADER_NAVIGATION: {
        Dashboard: 'Nadzorna ploča',
        Sheets: 'Radni listovi',
        Import: 'Uvoz',
        'Remote jobs': 'Aplikacije',
        Dimensions: 'Dimenzije',
    },
    ENTITY_TYPE: {
        DIMENSION_TABLE: 'Dimenzijska tablica',
        DIMENSION_MEMBER: 'Član dimenzije',
        VARIABLE: 'Varijabla',
        FOLDER: 'Mapa',
        FUNCTION: 'Funkcija',
        LITERAL: 'Literal',
        PROPERTY: 'Svojstvo',
        FILE: 'Datoteka',
        DASHBOARD: 'Nadzorna ploča',
        REMOTE_JOB: 'Aplikacija',
        SHEET: 'Radni list',
        TILE: 'Pločica',
    },
    ENTITY_TYPES: {
        DIMENSION_TABLE: 'Dimenzijske tablice',
        DIMENSION_MEMBER: 'Članovi dimenzija',
        VARIABLE: 'Varijable',
        FOLDER: 'Mape',
        FUNCTION: 'Funkcije',
        LITERAL: 'Literali',
        PROPERTY: 'Svojstva',
        FILE: 'Datoteke',
        DASHBOARD: 'Nadzorne ploče',
        REMOTE_JOB: 'Aplikacije',
        SHEET: 'Radni listovi',
        TILE: 'Elementi',
    },
    ITEM: 'Stavka',
    ITEM_TYPE: 'Vrsta stavke',
    FOLDER_ITEM: {
        DASHBOARD: 'Nadzorne ploče',
        DIMENSION_TABLE: 'Tablice dimenzija',
        VARIABLE: 'Varijable',
        SHEET: 'Radni listovi',
        FOLDER: 'Mape',
        FARSEER_FILE: 'Datoteke',
        REMOTE_JOB: 'Aplikacije',
    },
    FOLDER_ITEMS: {
        DASHBOARD: 'Nadzorne ploče',
        DIMENSION_TABLE: 'Tablice dimenzija',
        VARIABLE: 'Varijable',
        SHEET: 'Radni listovi',
        FOLDER: 'Mape',
        FARSEER_FILE: 'Datoteke',
        REMOTE_JOB: 'Aplikacije',
    },
    TABLE_SETTINGS_TEMPLATE_PATTERNS: {
        UUID: 'generira univerzalni jedinstveni identifikator',
        YYYY: 'ubacuje trenutnu godinu',
        YY: 'ubacuje posljednje dve cifre trenutne godine',
        MM: 'ubacuje trenutni mesec',
        DD: 'ubacuje trenutni dan',
        SSSSSSSS: 'ubacuje serijski broj dužine trenutne tabele + 1, definišite dužinu prema broju karaktera "S" (1-8)',
    },
    CONFIG_MENU_SECTIONS: {
        'Users & Permissions': 'Korisnici i dozvole',
        'Users & Groups': 'Korisnici i grupe',
        System: 'Sustav',
        'Input Setup': 'Podešavanje unosa',
        Locks: 'Zaključavanje',
        'Backup & Restore': 'Sigurnosna kopija i obnova',
        'Audit Logs': 'Zapisnici revizije',
        'Export Model': 'Izvoz modela',
        'Import Model': 'Uvoz modela',
        'Switch Tenants': 'Promjena radnog prostora',
        Support: 'Podrška',
        'Help Center': 'Centar za pomoć',
        'Contact Support': 'Kontaktiraj podršku',
    },
    KPI_COLUMN_OPERATIONS: {
        minus: 'minus',
        divide: 'dijeli',
        plus: 'plus',
        multiply: 'množi',
        percent: 'postotak',
        'percent thousands': 'postotak tisuća',
        'difference in %': 'razlika u %',
    },
    STATUS_MAP: {
        Resolved: 'Riješeno',
        Unresolved: 'Neriješeno',
        'In Review': 'U pregledu',
        QUEUED: 'U redu',
        RUNNING: 'U toku',
        FINISHED: 'Završeno',
        ERROR: 'Greška',
    },
    USER_CLASS_PERMISSIONS_TITLE_MAP: {
        'Create User': 'Kreiraj korisnika',
        'Delete User': 'Izbriši korisnika',
        'Find All Users': 'Pronađi sve korisnike',
        'Get User': 'Dohvati korisnika',
        'Update User': 'Ažuriraj korisnika',
    },
    FEATURE_PERMISSIONS_TITLE_MAP: {
        TAGS_IN_MODEL: 'Traka redova/stupaca',
        CLUSTER_FLOW_ADD: 'Dodavanje reda',
        YEAR_VERSION_LOCKS: 'Zaključavanja',
        IMPORT: 'Uvoz',
        SEE_ALL_IMPORT_JOBS: 'Prikaži sve poslove uvoza',
        USERS_GROUPS_MANAGEMENT: 'Upravljanje korisnicima i grupama',
        REMOTE_JOBS: 'Aplikacije',
        COMMENTS: 'Komentari',
        TAGS_SIDEBAR: 'Traka s bazama podataka',
        CREDENTIALS: 'Prijavnice',
        INPUT_SETUP: 'Podešavanje unosa',
        AUDIT_LOGS: 'Pregled zapisnika revizije',
        ASSIGNMENTS: 'Zadaci',
        BACKUP_AND_RESTORE: 'Sigurnosno kopiranje i obnavljanje',
        DASHBOARD_TO_IMAGE: 'Izvoz nadzorne ploče u sliku',
        CHAT_AI: 'Razgovor AI',
        DELETE_DIMENSION: 'Obriši dimenziju',
        FORECAST: 'Prognoza',
        GOAL_SEEKING_TOP_DOWN: 'Traženje cilja top down',
        MODEL_IMPEX: 'Uvoz/Izvoz modela',
        OWD_MEASURES: 'Samo s podacima za mjere',
        FORMULA_QA: 'Formula QA',
        USE_HIERARCHY_IN_CALCULATION: 'Ažuriraj "koristi hijerarhiju" u varijablama',
        MODEL_HEALTH: 'Zdravlje modela',
        FARSEER_LABS: 'Farseer Labs',
        FARSEER_LOGO: 'Farseer logo',
    },
    CELL_CLASS_PERMISSIONS_TITLE_MAP: {
        'Edit Cells': 'Uredi ćelije',
    },
    FOLDER_CLASS_PERMISSIONS_TITLE_MAP: {
        'Create Folder': 'Kreiraj mapu',
        'Duplicate Folder': 'Dupliraj mapu',
        'Search Folders': 'Pretraga mapa',
        'Get Items in Folder': 'Dohvati stavke u mapi',
        'Find by Reverse References': 'Pronađi po obrnutim referencama',
        'Move Items': 'Premjesti stavke',
        'Rename Items': 'Preimenuj stavke',
        'Delete Items in Folder': 'Izbriši stavke iz mape',
        'Share Folder Hierarchy': 'Podijeli hijerarhiju mape',
    },
    TAG_CLASS_PERMISSIONS_TITLE_MAP: {
        'Create Database Object': 'Kreiraj objekt baze podataka',
        'Delete Database Object': 'Izbriši objekt baze podataka',
        'Get Database Object': 'Dohvati objekt baze podataka',
        'Update Database Object': 'Ažuriraj objekt baze podataka',
        'Search Database Objects': 'Pretraži objekte baze podataka',
    },
    SHEET_CLASS_PERMISSIONS_TITLE_MAP: {
        'Create Sheet': 'Kreiraj radni list',
        'Get Sheet': 'Dohvati radni list',
        'Update Sheet': 'Ažuriraj radni list',
        'Duplicate Sheet': 'Dupliciraj radni list',
        'Search Rows in Sheet': 'Pretraži redove u radnom listu',
        'Get Sheet Data': 'Preuzmi podatke radnog lista',
        'Set Sheet Data': 'Postavi podatke radnog lista',
    },
    SHEET_ROW_CLASS_PERMISSIONS_TITLE_MAP: {
        'Create Row': 'Kreiraj redak',
        'Update Row': 'Ažuriraj redak',
        'Delete Row': 'Obriši redak',
        'Move Row': 'Premjesti redak',
        'Duplicate Row': 'Dupliciraj redak',
        'Find All Row': 'Pronađi sve retke',
        'Get Row': 'Preuzmi redak',
        'Materialize Row': 'Materijaliziraj redak',
    },
    SHARE_CLASS_PERMISSIONS_TITLE_MAP: {
        'Create Share': 'Kreiraj zadatke',
        'Add Public Shares': 'Kreiraj javni zadatak',
        'Delete Share': 'Obriši zadatak',
        'Get Share': 'Preuzmi zadatak',
        'Update Share': 'Ažuriraj zadatak',
    },
    LABEL_CLASS_PERMISSIONS_TITLE_MAP: {
        'Get Label': 'Dohvati oznaku',
        'Create Label': 'Stvori oznaku',
        'Update Label': 'Ažuriraj oznaku',
        'Delete Label': 'Izbriši oznaku',
    },
    FARSEER_FILE_CLASS_PERMISSIONS_TITLE_MAP: {
        'Create File': 'Kreiraj datoteku',
        'Update File': 'Ažuriraj datoteku',
        'Delete File': 'Obriši datoteku',
        'Find All Files': 'Pronađi sve datoteke',
        'Get File': 'Preuzmi datoteku',
    },
    REMOTE_JOB_CLASS_PERMISSIONS_TITLE_MAP: {
        'Create Remote Job': 'Kreiraj aplikaciju',
        'Update Remote Job': 'Ažuriraj aplikaciju',
        'Find All Remote Jobs': 'Pronađi sve aplikacije',
        'Get Remote Job': 'Preuzmi aplikaciju',
        'Run Remote Job': 'Pokreni aplikaciju',
        'Run Remote Job As A Service': 'Pokreni aplikaciju kao uslugu',
    },
    OVERSEER_CLASS_PERMISSIONS_TITLE_MAP: {
        'Restore Backup': 'Vrati sigurnosnu kopiju',
        'Create Backup': 'Kreiraj sigurnosnu kopiju',
        'Search Backups': 'Pretraži sigurnosnu kopije',
        'Download Backup': 'Preuzmi sigurnosnu kopiju',
        'Upload Backup': 'Učitaj sigurnosnu kopiju',
    },
    MODEL_CLASS_PERMISSIONS_TITLE_MAP: {
        'Read Model': 'Čitanje modela',
        'Edit Model': 'Uređivanje modela',
    },
    DASHBOARD_CLASS_PERMISSIONS_TITLE_MAP: {
        'Create Dashboard': 'Kreiraj nadzornu ploču',
        'Duplicate Dashboard': 'Dupliciraj nadzornu ploču',
        'Find All Dashboards': 'Pronađi sve nadzorne ploče',
        'Get Dashboard': 'Preuzmi nadzornu ploču',
        'Update Dashboard': 'Ažuriraj nadzornu ploču',
    },
    FEATURE_PERMISSION_TITLES: {
        FeaturePermission: 'Dozvola za funkciju',
        FolderClassPermission: 'Dozvola za klasu mape',
        TagClassPermission: 'Dozvola za klasu oznaka',
        SheetClassPermission: 'Dozvola za klasu radnog lista',
        SheetRowClassPermission: 'Dozvola za klasu reda radnog lista',
    },
    SEARCH_TAGS: 'Pretraži oznake...',
    SEARCH_PERMISSIONS: 'Pretraži dozvole...',
    DEFAULT: 'Zadano',
    FEATURE_PERMISSIONS: 'Dozvole za funkcije',
    CLASS_PERMISSIONS: 'Dozvole za klase',
    ADD_COMMENT: 'Dodaj komentar',
    SORT: 'Sortiraj',
    SORT_BY: 'Sortiraj po',
    ASCENDING: 'Uzlazno',
    DESCENDING: 'Silazno',
    UNSORT: 'Ne sortiraj',
    AUTO: 'Auto',
    LEFT: 'Lijevo',
    ALL_MONTHS: 'Svi mjeseci',
    TWELVE_MONTHS: '12 mjeseci',
    YEAR_START: 'Početak godine',
    TIMELINE_START: 'Početak vremenske trake',
    COPY_HASH_TAG: 'Kopiraj #',
    SHOW_TOP: 'Prikaži najboljih',
    SHOW_REST: 'Prikaži ostatak',
    RIGHT: 'Desno',
    CENTER: 'Sredina',
    TOP: 'Vrh',
    MIDDLE: 'Sredina',
    BOTTOM: 'Dno',
    YEAR_END: 'Kraj godine',
    TIMELINE_END: 'Kraj vremenske trake',
    CURRENT_YEAR: 'Trenutna godina',
    PREVIOUS_YEAR: 'Prethodna godina',
    CUSTOM: 'Prilagođeno',
    NEW_TABLE: 'Nova {name}',
    EDIT_TABLE: 'Uredi {name}',
    FOCUS_TABLE: 'Fokusiraj {name}',
    ROUND: 'Zaokruži',
    REGRESSION: 'Regresija',
    RANDOM: 'Nasumični broj',
    SET_VALUE: 'Postavi vrijednost',
    APPLY_PERCENTAGE: 'Primijeni postotak',
    APPLY_PERCENTAGE_CHAR: 'Primijeni %',
    DELETE_COLUMNS_ON_ROW: 'Obriši stupce na retku',
    PROCESSING_FILE: 'Obrada datoteke',
    IMAGE_PREVIEW_FAILED: 'Prikaz slike nije uspio',
    NEXT: 'Sljedeće',
    PREVIOUS: 'Prethodno',
    PAGE_OF: 'Stranica {pageNumber} od {pages}',
    NO_TITLE: 'Bez naslova',
    DURATION: 'Trajanje',
    CELL_COUNT: 'Broj ćelija',
    NONCALCULATED: 'Neizračunato',
    CALCULATED: 'Izračunato',
    SEARCH_ASSIGNMENTS: 'Pretraži zadatke',
    BY_NAME: 'Po imenu',
    BY_LABEL: 'Po oznaci',
    BY_STATUS: 'Po statusu',
    BY_SHEET: 'Po radnom listu',
    GROUP_BY: 'Grupiraj po',
    CHART_SPACING: 'Razmak grafikona',
    GRID_COLUMNS: 'Stupci mreže',
    GRID_SPACING: 'Razmak mreže',
    AXIS_SPACING: 'Razmak osi',
    RESET_FILTERS: 'Resetiraj filtere',
    RESET_CONFIG: 'Resetiraj konfiguraciju',
    RESET_CONFIG_TOOLTIP: 'Resetiraj konfiguraciju na zadane',
    BY_ASSIGNEE: 'Po izvršiocu',
    BY_APPROVER: 'Po odobravatelju',
    NEW_ASSIGNMENT: 'Novi zadatak',
    NEXT_ASSGN_DUE: 'Sljedeći zadatak ističe',
    SHARE_SELECT_USER_PLACEHOLDER: 'Pretraži korisnike ili grupe...',
    CREATE_ASSIGNMENT_PLACEHOLDER: 'Kreiraj zadatak odabirom korisnika...',
    ASSIGNMENT_REFRESHED: 'Produžen rok završetka zadatka za 7 dana',
    CANT_EDIT_ASSIGNMENT: 'Ne može se uređivati već podneseni zadaci',
    NO_CHANGES: 'Bez promjena',
    APPROVED: 'Odobreno',
    EXPIRED: 'Isteklo',
    READY_FOR_REVIEW: 'Spremno za pregled',
    IN_PROGRESS: 'U tijeku',
    SHARED: 'Podijeljeno',
    SHARED_WITH: 'Podijeljeno s',
    ARCHIVED: 'Arhivirano',
    STILL_STUCK: 'Još uvijek zaglavljeni? Posjetite naš centar za pomoć.',
    NEED_HELP: 'Treba vam pomoć? Posjetite naš centar za pomoć.',
    WELCOME: 'Dobrodošli',
    WELCOME_MESSAGE: 'Odaberite nešto s bočne trake kako biste počeli, ili pretražite nešto specifično.',
    DEFAULT_MEMBER: 'Zadani član',
    FAILED_TO_LOAD_MODEL: 'Model nije učitan',
    MODEL_LOADED: 'Model učitan',
    PREVIOUS_MESSAGE_IS_PROCESSING: 'Vaš prethodni zahtjev se obrađuje. Molimo sačekajte...',
    RUN_ARGUMENTS: 'Pokreni argumente',
    EXPECTED_ARGUMENTS: 'Očekivani argumenti',
    RUN_ARGUMENTS_ERROR: 'Argumenti za pokretanje radnje su zastareli, molimo da ih ažurirate.',
    GENERAL: 'Opći',
    SYSTEM: 'Sustav',
    BASIC_INFO: 'Osnovne informacije',
    LAST_RUN: 'Posljednje pokretanje',
    NEVER_RUN: 'Nikad pokrenuto',
    REMOTE_JOB_NAME: 'Naziv aplikacije',
    CHOOSE_FOLDER: 'Odaberi mapu',
    SOURCE_FOLDER: 'Izvorna mapa',
    SELECT_SOURCE_FOLDER_WARNING: 'Odaberite izvornu mapu',
    MAIN_FILE_HINT: 'Pritisnite na datoteku da biste označili skriptnu datoteku kao ulaznu točku',
    NO_FILES: 'Nema datoteka',
    NO_MAIN_FILE: 'Nema glavne datoteke',
    FINDER_TOOLTIP: 'Prikaz tražilice',
    VARIABLE_TOOLTIP: 'Prikaz trake za varijable',
    sheet_ITEMS_TOOLTIP: 'Prikaz stavki radnog lista',
    LIST_ITEMS_TOOLTIP: 'Prikaži stavke popisa',
    EXPAND_TOOLTIP: 'Proširi sve redove za jedan nivo',
    COLLAPSE_TOOLTIP: 'Skupi sve redove za jedan nivo',
    UNDO_TOOLTIP: 'Poništi',
    REDO_TOOLTIP: 'Ponovi',
    UNDO_HISTORY_RESET: 'Povijest poništavanja je poništena',
    UNDO_UNAVAILABLE_NOT_SUPPORTED: 'Ova promjena se ne može poništiti',
    UNDO_UNAVAILABLE_TOO_LARGE: 'Ova promjena je prevelika za poništavanje',
    UNDO_UNAVAILABLE_NO_INVERSE: 'Poništavanje više nije dostupno',
    UNDO_UNAVAILABLE_NO_LONGER_ALLOWED: 'Ova promjena se više ne može poništiti',
    UNDO_UNAVAILABLE_GENERIC: 'Ova promjena se ne može poništiti',
    FORECAST_TOOLTIP: 'Prikaz napretka prognoze',
    EXPORT_TOOLTIP: 'Izvezi u .xlsx',
    APP_SHORTCUTS_TOOLTIP: 'Prečaci aplikacija',
    TAGS_SIDEBAR_TOOLTIP: 'Otvori bočnu traku baza podataka',
    TILE_SIDEBAR_TOOLTIP: 'Otvori bočnu traku za uređivanje elementa',
    COMMENTS_SIDEBAR_TOOLTIP: 'Otvori bočnu traku komentari',
    ADD_APP_SHORTCUT: 'Dodaj prečac',
    APP_SHORTCUTS_PATH: 'Prečaci aplikacija',
    CHANGE_SHORTCUT_ACTION: 'Promijeni radnju',
    REMOVE_SHORTCUT: 'Ukloni prečac',
    SHORTCUT_ADDED: 'Prečac uspješno dodan',
    SHORTCUT_REMOVED: 'Prečac uklonjen',
    SHORTCUT_ALREADY_EXISTS: 'Prečac već postoji',
    CHANGE_ACTION_TITLE: 'Promijeni radnju',
    CHANGE_ACTION_LABEL: 'Odaberite jednu od sljedećih radnji',
    ACTION_CHANGED: 'Radnja promijenjena',
    ERROR_FETCHING_APP_DATA: 'Greška pri dohvaćanju podataka aplikacije',
    ERROR_FETCHING_ACTION_ARGUMENTS: 'Greška pri dohvaćanju argumenata radnje',
    INVALID_ACTION_ARGUMENTS: 'Nevažeći argumenti radnje',
    APP_STARTED_SUCCESSFULLY: 'Aplikacija uspješno pokrenuta',
    CREATE_BACKUP: 'Kreiraj sigurnosnu kopiju',
    BACKUP: 'Sigurnosna kopija',
    CREATE_BACKUP_WARNING: 'Jeste li sigurni da želite kreirati novu sigurnosnu kopiju?',
    RESTORE_BACKUP: 'Vrati sigurnosnu kopiju',
    RESTORE: 'Vrati',
    RESTORE_BACKUP_WARNING: 'Jeste li sigurni da želite vratiti se na sigurnosnu kopiju {backupPath}?',
    SELECT_MONTH: 'Odaberite mesec',
    REMOVE_FILTER: 'Ukloni filter',
    FILTER_BY: 'Filtriraj po...',
    STATIC_FILTER: 'Ovaj filter se ne može mijenjati',
    SELECT_ROW_TO: 'Odaberite red za pregled ili izmjenu njegove varijable',
    EDIT_ARGUMENT: 'Uredi argument',
    ARGUMENT_NAME: 'Ime argumenta',
    DATA_TYPE_STRING: 'Tekst',
    DATA_TYPE_BOOLEAN: 'Boolean',
    DEFAULT_VALUE: 'Podrazumijevana vrijednost',
    ADD_OPTION: 'Dodaj opciju',
    OPTION_VALUE: 'Vrijednost opcije',
    DROPDOWN_OPTIONS_MUST_BE_UNIQUE: 'Opcije moraju biti jedinstvene',
    DROPDOWN_OPTION_EMPTY: 'Opcija ne smije biti prazna',
    DROPDOWN_DEFAULT_AUTO_HINT: 'Nije odabrana zadana vrijednost — pri spremanju koristit će se prva opcija.',
    LOCKED_AT_RUN_TIME: 'Zaključaj vrijednost pri pokretanju',
    LOCKED_AT_RUN_TIME_TOOLTIP: 'Kada je označeno, korisnici pri pokretanju ne mogu mijenjati ovu vrijednost.',
    LOCKED_REQUIRES_DEFAULT: 'Zaključani argument mora imati zadanu vrijednost',
    SECRET: 'Tajna',
    SECRET_TOOLTIP: 'Vrijednost je maskirana tijekom unosa i u logovima',
    NAME_REQUIRED: 'Ime je obavezno',
    BACKUP_CREATED: 'Sigurnosna kopija kreirana',
    DOWNLOADING_BACKUP: 'Preuzimanje sigurnosne kopije',
    BACKUP_RESTORED: 'Sigurnosna kopija obnovljena',
    BACKUP_SEARCH_FAILED: 'Učitavanje sigurnosnih kopija nije uspjelo. Pokušajte ponovno.',
    UPLOAD_BACKUP: 'Učitaj sigurnosnu kopiju',
    UPLOADING: 'Učitavanje',
    SHOW_UPLOADED: 'Prikaži uploadane',
    INITIATED_BY: 'Pokrenuo',
    SAVE_AS_IMAGE: 'Spremi kao sliku',
    CREATING_AND_SAVING_IMAGE: 'Stvaranje slike i spremanje u datoteke...',
    IMAGE_SAVED: 'Slika spremljena!',
    FAILED_TO_SAVE_IMAGE: 'Spremanje slike nije uspjelo',
    GOAL_VALUE: 'Ciljna vrijednost',
    CURRENT_VALUE: 'Trenutna vrijednost',
    PERCENTAGE_MET: '{percentage}% ispunjeno',
    UNFREEZE_CELLS: 'Odmrzni vrijednosti',
    FREEZE_CELLS: 'Zamrzni vrijednosti',
    UNSET_GOAL: 'Ukloni kao ciljnu vrijednost',
    SET_GOAL: 'Postavi kao ciljnu vrijednost',
    INSPECT_VALUE: 'Istraži vrijednost',
    EDITING_TILE: 'Uređivanje elementa',
    NO_TILE_SELECTED: 'Molimo odaberite element.',
    NO_TILE_OPTIONS: 'Nema dostupnih opcija.',
    TILE_NAME: 'Naziv elementa',
    ENTER_TILE_NAME: 'Unesite naziv elementa',
    USE_FILTERS_FROM: 'Koristi filtere iz',
    USE_SORT_FROM: 'Koristi sortiranje iz',
    USE_TIMELINE_FROM: 'Koristi vremensku crtu iz',
    SHOW_TILE_SORT: 'Prikaži sortiranje ove pločice',
    SHOW_TILE_FILTERS: 'Prikaži filtere pločice',
    SHOW_TILE_TIMELINE: 'Prikaži vremensku crtu pločice',
    DASHBOARD: 'Nadzorna ploča',
    TILE: 'Element',
    TILE_COPIED: 'Element je kopiran!',
    CHART_COLUMN_OPTIONS: 'Opcije stupca',
    CHART_ROW_OPTIONS: 'Opcije reda',
    GENERAL_STYLING: 'Opće stiliziranje',
    PER_ROW_STYLING: 'Stiliziranje po redu',
    PER_COLUMN_STYLING: 'Stiliziranje po stupcu',
    TEXT_STYLE: 'Stil teksta',
    ROW_STYLE: 'Stil reda',
    COLOR: 'Boja',
    PALETTE: 'Paleta',
    BACKGROUND: 'Pozadina',
    BORDER: 'Obrub',
    SHADOW: 'Sjena',
    TOP_BORDER: 'Gornji obrub',
    BOTTOM_BORDER: 'Donji obrub',
    INNER_BORDER: 'Unutarnji obrub',
    RESET_GENERAL_STYLES: 'Resetiraj opće stilove',
    RESET_ALL_PER_ROW_STYLES: 'Resetiraj sve stilove po redu',
    RESET_ALL_PER_COLUMN_STYLES: 'Resetiraj sve stilove po stupcu',
    RESET_STYLES: 'Resetiraj stilove',
    ADD_TABLE: 'Nova dimenzijska tablica',
    ADD_VARIABLE: 'Nova varijabla',
    ADD_SHEET: 'Novi radni list',
    ADD_DASHBOARD: 'Novi nadzorna ploča',
    ADD_APP: 'Dodaj aplikaciju',
    ADD_FILE: 'Dodaj datoteku',
    ADD_FOLDER: 'Dodaj mapu',
    ENABLED: 'Omogućeno',
    NEW_TEMPLATE: 'Novi predložak',
    EDIT_TEMPLATE: 'Uredi predložak',
    SAVE_SELECTION_AS_TEMPLATE: 'Spremi odabir kao predložak',
    TEMPLATE_CREATED: 'Predložak kreiran',
    TEMPLATE_UPDATED: 'Predložak ažuriran',
    TEMPLATE_DELETED: 'Predložak obrisan',
    TEMPLATE_NAME: 'Naziv predloška',
    TEMPLATE_DESCRIPTION: 'Opis predloška',
    QUANTITY: 'Količina',
    ENTER_TEXT: 'Unesite tekst',
    ENTER_NUMBER: 'Unesite broj',
    PICK_A_DATE: 'Odaberite datum',
    ERROR_CREATING_DIMENSION: 'Greška prilikom kreiranja nove dimenzije',
    ALLOW_MULTI_CREATE: 'Dopusti kreiranje više stavki odjednom',
    ALLOW_NAME_DESC_CONN_ON_CREATE: 'Postavi naziv, opis i veze pri kreiranju',
    ALLOW_PROPERTIES_ON_CREATE: 'Postavi svojstva pri kreiranju',
    NAMING_CONFIG_ENABLED: '(Konfiguracija imenovanja omogućena)',
    DIMENSION_TABLE: 'Dimenzijska tablica',
    DIMENSION_TABLES: 'Dimenzijske tablice',
    DIMENSION_MEMBER: 'Član dimenzije',
    DIMENSION_MEMBERS: 'Članovi dimenzije',
    ASK_WHEN_CREATING: 'Pitaj prilikom kreiranja',
    PREDEFINED_CONNECTIONS: 'Unaprijed definirane veze',
    REQUIRED: 'Potrebno',
    CHOOSE_A_TABLE_FIRST: 'Prvo izaberite tablicu za postavljanje veza',
    BIND_TO_TIMELINE: 'Poveži s vremenikom',
    NEW_VARIABLE_COLUMN: 'Novi stupac varijable',
    NEW_DIMENSION_COLUMN: 'Novi stupac dimenzije',
    NEW_LOOKUP_COLUMN: 'Novi stupac pretrage',
    NEW_COMPARISON_COLUMN: 'Novi stupac za usporedbu',
    EDITING_CUSTOM_COLUMN: 'Uređivanje prilagođenog stupca',
    LOOKUP_PROPERTIES: 'Svojstva pretrage',
    CALCULATION_COLUMN: 'Stupac za računanje',
    ADD_COLUMNS: 'Dodaj stupce',
    COLUMN_NAME: 'Naziv stupca',
    DELETE_CUSTOM_COLUMN_CONFIRMATION: 'Jeste li sigurni da želite obrisati ovaj stupac?',
    AUTOGENERATED_CUSTOM_COLUMN_NAME: 'Ostavite prazno za automatski generirano ime',
    NOTE_INSPECT_VALUE: 'Napomena: Funkcija "Istraži vrijednost" prikazuje samo do 500 redova. Za pregled svih podataka, izvezite kompletni skup podataka.',
    COPY_FROM: 'Kopiraj iz',
    COPY_FROM_TAGNAME: 'Kopiraj iz {tag}',
    PREVIEW: 'Pregled',
    DECIMALS: 'Decimalna mjesta',
    SIGNS: 'Negativni brojevi',
    NEGATIVE_SIGNS: {
        SIGNED: 'Minus',
        UNSIGNED: 'Zagrada',
        EXPLICIT: 'Plus/Minus',
    },
    POLARITY_SIGNS: {
        POSITIVE: 'Pozitivno',
        NEGATIVE: 'Negativno',
    },
    BASE_UNIT: 'Osnovna jedinica',
    BASE_UNITS: {
        ONES: 'Jedna',
        THOUSANDS: 'Tisuće',
        THOUSANDS_K: 'Tisuće (k)',
        MILLIONS: 'Milioni',
        MILLIONS_M: 'Milijuni (m)',
        BILLIONS: 'Milijarde',
        BILLIONS_B: 'Milijarde (b)',
        AUTO: 'Automatski',
    },
    CURRENCY_UNITS: {
        EUR: '€',
        USD: '$',
        HRK: 'HRK',
    },
    MONTHS: {
        January: 'Siječanj',
        February: 'Veljača',
        March: 'Ožujak',
        April: 'Travanj',
        May: 'Svibanj',
        June: 'Lipanj',
        July: 'Srpanj',
        August: 'Kolovoz',
        September: 'Rujan',
        October: 'Listopad',
        November: 'Studeni',
        December: 'Prosinac',
    },
    MONTHS_SHORT: {
        Jan: 'Sij',
        Feb: 'Velj',
        Mar: 'Ožu',
        Apr: 'Tra',
        May: 'Svi',
        Jun: 'Lip',
        Jul: 'Srp',
        Aug: 'Kol',
        Sep: 'Ruj',
        Oct: 'Lis',
        Nov: 'Stu',
        Dec: 'Pro',
    },
    DAYS: {
        Sunday: 'Nedjelja',
        Monday: 'Ponedjeljak',
        Tuesday: 'Utorak',
        Wednesday: 'Srijeda',
        Thursday: 'Četvrtak',
        Friday: 'Petak',
        Saturday: 'Subota',
    },
    DAYS_SHORT: {
        Sun: 'Ned',
        Mon: 'Pon',
        Tue: 'Uto',
        Wed: 'Sri',
        Thu: 'Čet',
        Fri: 'Pet',
        Sat: 'Sub',
    },
    CURRENCY: 'Valuta',
    SIGNING_IN: 'Prijavljivanje...',
    NEW_RELATION_COLUMN: 'Novi stupac relacije',
    SELECT_TABLE_LOOKUP: 'Odaberite tablicu za pretraživanje',
    SELECT_TABLE_RELATION: 'Poveži članove reda s',
    SELECT_TABLE_PROPERTY: 'Odaberite svojstvo iz tablice',
    DISPLAY_TABLE_PROPERTY: 'Prikaži svojstvo iz tablice',
    FILTER_MEMBERS: 'Filtriraj odabir članova filterima radnog lista',
    TABLE_RELATION: 'Relacija tablice',
    FILTER_DISPLAY: 'Filtriraj prikaz',
    RELATE_TABLE: 'Poveži s tablicom',
    USE_BLANKS: 'Koristi prazna polja',
    NO_DATA_TO_DISPLAY: 'Nema podataka za prikaz',
    USE_REFERENCE_SORT: 'Koristi njegovo sortiranje',
    USE_REFERENCE_FILTERS: 'Koristi njegove filtere',
    USE_REFERENCE_TIMELINE: 'Koristi njegovu vremensku liniju',
    USE_REFERENCE_TEMPLATES: 'Koristi njegove predloške',
    USE_REFERENCE_ROWS: 'Koristi njegove redove',
    USE_REFERENCE_COLUMNS: 'Koristi njegove stupce',
    REFERENCE_ANOTHER_SHEET: 'Referenciraj drugi radni list',
    NO_SHEET_SELECTED: 'Nijedan radni list nije odabran',
    SELECT_SHEET: 'Odaberite radni list',
    SHEET_REFERENCED: 'Radni list uspješno referenciran',
    CANNOT_ADD_ROWS: 'Nije moguće dodati redove dok je referencirano',
    CANNOT_EDIT_ROWS: 'Nije moguće uređivati redove dok je referencirano',
    CANNOT_EDIT_COLUMNS: 'Nije moguće uređivati stupce dok je referencirano',
    CANNOT_ADD_COLUMNS: 'Nije moguće dodati stupce dok je referencirano',
    CANNOT_ADD_FILTERS: 'Nije moguće dodati filtere dok je referencirano',
    REVERSE_DIMENSION: 'obrnuto povezana dimenzija',
    REMOVE_FROM_RULE: 'Ukloni iz pravila',
    NEW_RULE: 'Novo pravilo',
    DUPLICATE_RULE: 'Dupliciraj pravilo',
    REMOVE_RULE: 'Ukloni pravilo',
    ENABLE_RULE: 'Omogući pravilo',
    DISABLE_RULE: 'Onemogući pravilo',
    RULE_DISABLED: 'Onemogućeno',
    VARIABLE_LOCK_INFO_TITLE: `Ova varijabla će koristiti samo ovo pravilo.`,
    VARIABLE_LOCK_INFO_BODY: `Ostala pravila bit će nadjačana. Za zaključavanje cijele varijable, ostavite odjeljak dimenzija prazan.`,
    DELETED: 'Obrisano',
    DONE: 'Gotovo',
    CHOOSE_ITEMS_TO_EXPORT: 'Odaberite stavke za izvoz',
    UPLOAD_MODEL_FILE: 'Učitajte datoteku modela',
    NO_FILE_SELECTED: 'Nijedna datoteka nije odabrana',
    BACK: 'Natrag',
    ALLOW_IMPORT_TO: 'Dopusti uvoz u',
    FINISHED: 'Završeno',
    IMPORT_PREVIEW: 'Ovo je pregled promjena koje bi uvoz primijenio s trenutnim postavkama.\n\nPromjene:\n',
    IMPORT_FINISHED: 'Uvoz završen.\n\nPromjene:\n',
    LOADING_MODEL: 'Uvoz modela iz datoteke...',
    CUSTOM_COLUMN: 'Prilagođeni stupac',
    EXPAND_ROW_COLUMN_TOOLBAR: 'Proširi traku redova i stupaca',
    SEARCH_FOR_EXPRESSIONS: 'Pretraži funkcije, varijable, dimenzije…',
    NEW: 'Novo',
    SELECT_A_CELL: 'Odaberite ćeliju s vrijednošću za pregled formule',
    SELECT_A_CELL_TO_EDIT_ROWS: 'Odaberite ćeliju za uređivanje redova',
    OR_COLUMNS: 'ili stupaca',
    MANAGE_PERMISSIONS_FOR: 'Upravljaj dozvolama za "{name}"',
    VIEW_ONLY: 'Samo pregled',
    DATA_EDIT: 'Uređivanje podataka',
    EDIT_OWNED: 'Uredi vlastito',
    FULL_EDIT: 'Potpuno uređivanje',
    UNKNOWN_USER: 'Nepoznati korisnik',
    UNKNOWN_GROUP: 'Nepoznata grupa',
    BUTTON_STYLE: 'Stil gumba',
    BUTTON_STYLES: {
        primary: 'Primarni',
        secondary: 'Sekundarni',
        tertiary: 'Tercijarni',
        quaternary: 'Kvarternarni',
    },
    APP_ICON: 'Ikona aplikacije',
    LAST_MODIFIED_BY: 'Zadnji put izmijenio/la {name}',
    LAST_MODIFIED_BY_COLUMN: 'Zadnje izmijenio/la',
    LAST_MODIFIED_AT_COLUMN: 'Zadnje izmijenjeno',
    SHOW: 'Prikaži',
    FORMULA_QA: 'Formula QA',
    TIME_LIMIT: 'Vremensko ograničenje',
    RESTRICTIONS: 'Ograničenja',
    SEARCH_FOR_USERS_GROUPS: 'Pretraži korisnike ili grupe…',
    SEARCH_OR_ADD_USERS_GROUPS: 'Pretraži ili podijeli s korisnicima, grupama ili javno…',
    STATUS_TRACKING: 'Praćenje statusa',
    STATUS_TRACKING_MESSAGE: 'Praćenje omogućuje korisniku ili grupi da pošalje promjene i zatraži vaše odobrenje.',
    TRACK_STATUS: 'Prati status',
    STOP_TRACKING: 'Zaustavi praćenje',
    RESTART_TRACKING: 'Ponovno pokreni praćenje',
    ALL: 'Sve',
    TRACKED: 'Praćeno',
    UNTRACKED: 'Nepraćeno',
    ALL_TRACKED: 'Svi praćeni',
    MY_TRACKED: 'Moji praćeni',
    MY_APPROVALS: 'Moja odobrenja',
    ALL_SHARES: 'Sva dijeljenja',
    SUPER_USERS: 'Super korisnici',
    LOADING_SUPER_USERS: 'Učitavanje super korisnika...',
    CANNOT_EDIT_WHEN_TIME_LIMIT: 'Nije moguće uređivati dok je vremensko ograničenje aktivno',
    CANNOT_EDIT_WHEN_TRACKED: 'Nije moguće uređivati dok se prati status',
    EXPORT_SHARES: 'Izvezi udjele',
    SHARE_COPIED: 'Dijeljenje kopirano!',
    SHARES_COPIED: 'Dijeljenja kopirana!',
    COPY_SHARE_IN_FOLDER: 'Kopiraj na sve u ovoj mapi',
    COPY_AND_OVERRIDE_SHARES: 'Kopiraj i zamijeni dijeljenja',
    COPY_AND_OVERRIDE_SHARES_CONFIRMATION: 'Sva postojeća dijeljenja na stavkama i mapama unutar ove mape bit će zamijenjena dijeljenjima trenutne mape.',
    COPY_ALL_SHARES_IN_FOLDER: 'Kopiraj i zamijeni sva dijeljenja u ovoj mapi',
    GRID_SINGLE_CHART_EXPLANATION: 'Jedan grafikon s redovima najviše razine',
    GRID_MULTIPLE_CHART_EXPLANATION: 'Mreža malih grafikona, po jedan za svaki red najviše razine',
    DUPLICATE_KEYS_FOUND: 'Pronađeni duplicirani ključevi',
    DUPLICATE_KEYS_PROMPT: 'Želite li filtrirati i kreirati samo jedinstvene stavke?',
    NAMES_SHOULD_BE_UNIQUE: 'Imena moraju biti jedinstvena',
    LIMIT_TO_FILTERED_OPTIONS: 'Ograniči na filtrirane opcije',

    // Toast messages
    SWITCHING_TENANT: 'Prebacivanje radnog prostora',
    TENANT_SWITCHED_SUCCESS: 'Radni prostor uspješno prebačen',
    TENANT_SWITCH_FAILED: 'Nije uspjelo učitati podatke novog radnog prostora. Molimo osvježite stranicu',
    FAILED_LOAD_MESSAGES: 'Nije uspjelo učitati poruke',
    NEW_CHAT_CREATED: 'Novi razgovor stvoren!',
    FAILED_LOAD_CHATS: 'Nije uspjelo učitati razgovore.',
    FAILED_CREATE_CHAT: 'Nije uspjelo stvoriti novi razgovor.',
    FAILED_SEND_MESSAGE: 'Nije uspjelo stvoriti novi razgovor ili poslati poruku.',
    FAILED_RENAME_CHAT: 'Nije uspjelo preimenovati razgovor.',
    FAILED_DELETE_CHAT: 'Nije uspjelo obrisati razgovor.',
    XLSX_FILE_ONLY: 'Samo .xlsx datoteke',
    JSON_FILE_ONLY: 'Samo .json datoteke',
    EXPORT_DONE: 'Gotovo!',
    LOCKS_SAVED: 'Zaključavanja spremljena',
    COPIED_TO_CLIPBOARD: 'Kopirano u međuspremnik',
    INVALID_INTERVAL: 'Nevažeći interval',
    SELECT_REQUIRED_DIMENSIONS: 'Odaberite potrebne dimenzije.',
    ENTITY_TYPE_NOT_SPECIFIED: 'Tip entiteta nije naveden',

    // Button labels
    OK: 'U redu',
    DELETE_ENTITY: 'Obriši entitet',
    SAVE_ENTITY: 'Spremi entitet',
    GENERATED_ENTITIES: 'Generirani entiteti',
    NEW_ENTITY: 'Novi entitet',
    ENTITIES: 'Entiteti',
    SHOW_LOGS: 'Prikaži zapisnike',
    CALCULATE: 'Izračunaj',
    FORMULA_QA_TITLE: 'Formula QA',
    RENAME_CHAT: 'Preimenuj razgovor',
    SEND: 'Pošalji',
    EXPORT_CURRENT_SHEET: 'Izvezi trenutni radni list',
    TERMINATE: 'Prekini',
    CONFIRM_UPDATE: 'Potvrdi ažuriranje',

    // Form labels and placeholders
    FROM_DATE: 'Od datuma',
    TO_DATE: 'Do datuma',
    AUDIT_TYPE: 'Tip revizije',
    SELECT_AUDIT_TYPE: 'Odaberite tip revizije',
    USER: 'Korisnik',
    PAGE_SIZE: 'Veličina stranice',
    SELECT_PAGE_SIZE: 'Odaberite veličinu stranice',
    SELECT_USER: 'Odaberite korisnika',
    EXPORT_EXPANDED_ROWS: 'Izvezi trenutno proširene retke',
    EXPORT_ALL_ROWS: 'Izvezi sve retke',
    EXPORT_FILENAME_LABEL: 'Naziv',
    EXPORT_VARIABLE: 'Izvezi varijablu',
    EXPORT_FORMAT: 'Format izvoza',
    EXPORT_FORMAT_XLSX: '.xlsx (Excel 2007 i noviji)',
    EXPORT_FORMAT_CSV_BOM: '.csv (kompatibilno s Excelom)',
    EXPORT_FORMAT_CSV: '.csv (čisti podaci)',
    EXPORT_FORMAT_JSON: '.json',
    INCLUDE_CELLS: 'Uključi ćelije',
    INCLUDE_MEMBERS: 'Uključi članove',
    MESSAGE_FARSEER_AI: 'Poruka za FarseerAI...',
    ENTER_NEW_CHAT_NAME: 'Unesite novi naziv razgovora',
    FLAG: 'Oznaka',

    // Chat suggestions
    CHAT_SUGGESTION_SUMMARY: 'Daj mi kratki sažetak modela',
    CHAT_SUGGESTION_DIMENSIONS: 'Postoje li varijable koje imaju više dimenzija od varijabli korištenih u njihovoj formuli?',
    CHAT_SUGGESTION_DELAY: 'Koriste li neke varijable funkciju delay()?',
    CHAT_SUGGESTION_ONDEMAND: 'Navedi sve varijable na zahtjev',
    CHAT_SUGGESTION_MEASURES: 'Navedi sve mjere',
    CHAT_SUGGESTION_FIXED: 'Navedi sve varijable koje koriste fiksnu dimenziju',
    CHAT_SUGGESTION_DATE: 'Navedi sve dimenzije koje imaju svojstvo datuma',

    // Loading defaults
    DEFAULT_LOADING: 'Učitavanje...',
    DEFAULT_SUCCESS: 'Uspjeh!',

    // Audit logs
    TOTAL_RESULTS: 'Ukupno rezultata: {count}',
    PAGE_OF_TOTAL: 'Stranica {current} od {total}',
    DB_ID: 'ID baze',
    DATE_AND_TIME: 'Datum i vrijeme',
    LOG_TYPE: 'Tip zapisnika',
    DATA: 'Podaci',

    // Entity debugger
    NO_TYPES: 'Nema tipova',

    // Formula QA Modal
    RESULT: 'Rezultat: {value}',
    ENTER_FORMULA_TO_CALCULATE: 'Unesite formulu za izračun rezultata.',

    // Model export
    EXPORTING_MODEL_ITEMS: 'Izvoz odabranih stavki modela...',

    // Search
    RECENTLY_SEARCHED: 'Nedavno pretraženo',
};

export default {
    ...(baseLanguageValues as Translation),
    ...translationValues,
};
